import "react-toastify/dist/ReactToastify.css";
import AssessmentDiscussionDraftChart from "../../components/Common/Charts/AssessmentDiscussionDraftChart";
import AudioTable from "./audiocallstable";
import FeedBackTable from "./Feedbacktable";
import Heatmap from "highcharts/modules/heatmap";
import Highcharts from "highcharts";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import NestedTabs from "./NestedTabs";
import PlotBarChart from "../../components/Common/Charts/PlotBarChart";
import React, { useEffect, useRef, useState } from "react";
import StudentSentimentChart from "../../components/Common/Charts/StudentSentimentChart";
import StudentTable from "./studentlist";
import SummaryAnalysis from "../../components/Common/SummaryAnalysis/SummaryAnalysis";
import UnitPerfomanceTable from "./unitperformanceTable";
// import TopicDiscussedTab from "../../components/Common/TopicDiscussedTab/TopicDiscussedTab";
import TopicDiscussedTab from "../../components/Common/TopicDiscussedTab/TopicDiscussedTabIsd";
import WebinarGridTable from "./webinarTable";
import WebinarInsightsTab from "../../components/Common/WebinarInsightsTab/WebinarInsightsTabIsd";
import WebinarPerfomance from "./WebinarPerfomance";
import RedFlagSessionTab from "./RedFlagSessionTab";
import axios from "axios";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";


// import { ChartTitle, withChartNavigation, weekNumberFromCategory } from "../../components/Common/ChartLink/ChartLink";

import { ChartTitle, withChartNavigation, weekNumberFromCategory } from "../../components/Common/ChartLink/ChartLink";

import {
  Container,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Tooltip,
  CardHeader,
} from 'reactstrap';
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Initialize the heatmap module
Heatmap(Highcharts);


// Tab names used on THIS page (different from the Unit page)
const TAB = {
  STUDENT_LIST: 'about',            // Student List
  ONE_TO_ONE: 'voice',              // Audio or Video Sessions
  RED_FLAG: 'Red Flag Sessions',

  WEBINARS: 'Webinars',
  WEBINAR_PERFORMANCE: 'Webinar Performance',

  INSIGHTS: 'Insights',

};

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};

// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};

// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

const IndividualTeacherReport = () => {
  document.title = 'Linc Quality Hub';

  const location = useLocation();
  const navigate = useNavigate();
  const teacherName = location.state?.teacherName;
  const Deatilsofteacher = location.state;
  // console.log('Deatilsofteacher', Deatilsofteacher);
  // // console.log("tdata", location.state)

  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);
  const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false);
  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [selectedUnits, setSelectedUnits] = useState(new Set());
  const [selectedTeachers, setSelectedTeachers] = useState(new Set());
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms

  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [appliedUnit, setAppliedUnit] = useState(new Set()); // New state for applied terms
  const [appliedTeacher, setAppliedTeacher] = useState(new Set());
  const [appliedPrograms, setAppliedProgram] = useState(new Set());

  // State for fetched data
  const [universities, setUniversities] = useState([]);
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]); // To store timeline terms
  const [timelineUnit, setTimelineUnit] = useState([]); // To store timeline terms
  const [timelineTeacher, setTimelineTeacher] = useState([]);
  const [timelineProgram, setTimelineProgram] = useState([]);

  // // console.log(timelineTeacher)
  //Modal
  const [modalOpen, setModalOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [natureOfFeedback, setNatureOfFeedback] = useState('');
  const [score, setScore] = useState('');
  const [timing, setTiming] = useState('');
  const [description, setDescription] = useState('');
  const [individualReport, setIndivdualReport] = useState(null);
  // console.log('overall data///////', individualReport);
  const [individualReportKpicards, setIndivdualReportkpicards] = useState(null);
  const [chartsData, setChartsData] = useState(null);
  const [avgcallData, setAvgCallData] = useState(null);
  const [callduration, setCallDuration] = useState({});
  const [responsive, setResponsiveness] = useState(null);
  const [studentList, setStudentList] = useState(null);
  const [callQualityMilestone, setCallQualityMilestone] = useState(null);

  const [payload, setpayload] = useState(null);

  const [avgperformance, setAvgPerformance] = useState(null);
  const [callqualityscore, setQuailtyRedFLages] = useState(null);
  // // console.log("stlist", avgperformance)
  const [loading, setLoading] = useState(true); // New loading state
  const [loading1, setLoading1] = useState(true); // New loading state
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [feedBackDeatils, setFeedBackDeatils] = useState(null);
  const [milestooneFeedback, setMilestoneFeedback] = useState(null);
  const [assesmentFeedback, setAssesmentFeedback] = useState(null);
  const [UnitPerfomanceTableData, setUnitPerformance] = useState(null);

  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [unitSearch, setUnitSearch] = useState('');
  const [teacherSearch, setTeacherSearch] = useState('');
  //stusts filter
  const [status, setStatus] = useState([]);
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [statusSearch, setStatusSearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(new Set());
  const [appliedStatus, setAppliedStatus] = useState(new Set());

  const [resetTrigger, setResetTrigger] = useState(0);

  //tooltip
  const [unitTooltipOpen, setUnitTooltipOpen] = useState(false);
  const [universityTooltipOpen, setUniversityTooltipOpen] = useState(false);
  const [loadingFilter, setLoadingFilters] = useState(false);
  const [flaggedSessionRes, SetflaggedSessionRes] = useState([]);
  const summarystudent = `
<div class='ai-summary'>
  Rashmi opened the session by introducing herself and reminding Mary that the call was recorded. 
  They discussed the key requirements and timelines for Assessment Three in Managing People, including tasks due on Saturday and Monday. 
  Mary expressed concern about meeting deadlines due to work commitments, and Rashmi emphasized the importance of timely submission to avoid penalties. 
  They also reviewed how to properly upload presentation files using Canva and ensure submission links work correctly. 
  The conversation ended with guidance on including reference lists and Mary feeling clear and confident about the next steps.
</div>
`;
  const toggleUnitTooltip = () => setUnitTooltipOpen(!unitTooltipOpen);

  // Helper to process comma-separated strings for tooltips
  const getFirstValue = (data) => (data ? data.split(',')[0] : '0');
  const getTooltipContent = (data) => (data ? data.split(',').join(', ') : '0');
  // Retrieve values from localStorage on component mount
  useEffect(() => {
    // Check if Deatilsofteacher and teacherid exist
    if (Deatilsofteacher?.teacherid) {
      // const teacherSet = new Set([Deatilsofteacher.teacherid]);
      // setAppliedTeacher(teacherSet);
      // saveToSessionStorage('appliedTeacher', teacherSet);
    }
  }, [Deatilsofteacher]);

  useEffect(() => {
    if (Deatilsofteacher) {
      removeFromSessionStorage('appliedUniversities');
      removeFromSessionStorage('appliedTimelines');
      removeFromSessionStorage('appliedTerms');
      removeFromSessionStorage('appliedUnit');
      removeFromSessionStorage('appliedPrograms');

      removeFromSessionStorage('selectedUniversities');
      removeFromSessionStorage('selectedTimelines');
      removeFromSessionStorage('selectedPrograms');
      removeFromSessionStorage('selectedUnits');
      removeFromSessionStorage('selectedTeachers');
      removeFromSessionStorage('selectedTerms');
    }
  }, [Deatilsofteacher]);

  useEffect(() => {
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelines'));
    setAppliedTerms(loadFromSessionStorage('appliedTerms'));
    setAppliedUnit(loadFromSessionStorage('appliedUnit'));
    setAppliedTeacher(loadFromSessionStorage('appliedTeacher'));
    setAppliedProgram(loadFromSessionStorage('appliedPrograms'));
    setAppliedStatus(loadFromSessionStorage('appliedstatus'));

    // Handle teacherid directly if passed from another page

    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedTimelines(loadFromSessionStorage('selectedTimelines'));
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));
    setSelectedUnits(loadFromSessionStorage('selectedUnits'));
    setSelectedTeachers(loadFromSessionStorage('selectedTeachers'));
    setSelectedTerms(loadFromSessionStorage('selectedTerms'));
    setSelectedStatus(loadFromSessionStorage('appliedstatus'));

    // teacher qc

    if (Deatilsofteacher?.teacherid) {
      const teacherSet = new Set([Deatilsofteacher.teacherid]);
      setAppliedTeacher(teacherSet);
      saveToSessionStorage('appliedTeacher', teacherSet);
      setSelectedTeachers(teacherSet);
      saveToSessionStorage('selectedTeachers', teacherSet);
      const university = new Set([...Deatilsofteacher.appliedUniversities]);
      setAppliedUniversities(university);
      setSelectedUniversities(university);
      saveToSessionStorage('appliedUniversities', Array.from(university));
      saveToSessionStorage('selectedUniversities', Array.from(university));

      const programtq = new Set([...Deatilsofteacher.appliedPrograms]);
      setAppliedProgram(programtq);
      saveToSessionStorage('appliedPrograms', Array.from(programtq));
      setSelectedPrograms(programtq);
      saveToSessionStorage('selectedPrograms', Array.from(programtq));

      if (Deatilsofteacher?.unit_id) {
        const unittq = new Set([Deatilsofteacher.unit_id]); // Wrap it in an array
        setAppliedUnit(unittq);
        saveToSessionStorage('appliedUnit', Array.from(unittq)); // Convert Set to Array before saving
        setSelectedUnits(unittq);
        saveToSessionStorage('selectedUnits', Array.from(unittq)); // Convert Set to Array before saving
      }
      if (
        Deatilsofteacher?.appliedTerms &&
        Deatilsofteacher?.appliedTimelines
      ) {
        const termArray = Array.from(Deatilsofteacher.appliedTerms); // Convert Set to Array
        const yearArray = Array.from(Deatilsofteacher.appliedTimelines); // Convert Set to Array

        setAppliedTerms(new Set(termArray)); // Update state if needed
        setAppliedTimelines(new Set(yearArray)); // Update state if needed
        setSelectedTimelines(new Set(yearArray));
        setSelectedTerms(new Set(termArray));
        saveToSessionStorage('appliedTerms', termArray); // Save as array
        saveToSessionStorage('selectedTerms', termArray); // Save as array

        saveToSessionStorage('appliedTimelines', yearArray);
        saveToSessionStorage('selectedTimelines', yearArray); // Save as array
        // Save as array
        // setSelectedPrograms(loadFromSessionStorage('selectedProgramsteacherqc'));
        // setSelectedUniversities(loadFromSessionStorage('selectedUniversitiesteacherqc'));
        // setSelectedTimelines(loadFromSessionStorage('selectedTimelinesteacherqc'));
        // setSelectedTerms(loadFromSessionStorage('selectedTermsteacherqc'));
      }
    } else {
    }
    // setLoading(false);
  }, []);

  // voice Analytics
  const [summary, setSummary] = useState(null);
  const [Topics, setTopics] = useState(null);
  const [qusetions, setQusetions] = useState(null);
  const [VoiceAnayticsaudio, SetVoiceAnayticsaudio] = useState(null);
  const [webinarAnalytics, SetwebinarAnalytics] = useState(null);
  const [VoiceAnayticsVideo, SetVoiceAnayticsvideo] = useState(null);
  const [classroom_id, setclassroom_id] = useState(null);
  const [Call_performance_response, setCall_performance_response] =
    useState(null);
  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      case 'unit':
        setUnitSearch(value);
        break;
      case 'teacher':
        setTeacherSearch(value); // Save search text for teachers
        break;
      default:
        break;
    }
  };

  const user_token = localStorage.getItem('usertoken');

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return timelineProgram.filter(([, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterTeachers = () => {
    return Array.isArray(timelineTeacher)
      ? timelineTeacher.filter((teacher) =>
        teacher.full_name.toLowerCase().includes(teacherSearch.toLowerCase()),
      )
      : [];
  };

  const handleEdit = (data) => {
    if (!data) return;
    console.warn(data);
    setEditNatureOfFeedback(data.NatureofFeedback);
    seteditFeedback_id(data.feedback_id);
    setEditTiming(data.Timing);
    setEditDescription(data.Description);
    setEditScore(data.Scores);
    toggleEditModal();
  };

  const handleDeleteFeedBack = async () => {
    // logic to delete axios here
    // DeletePayload
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    try {
      // Replace with your actual API endpoint
      console.warn({ DeletePayload });
      // return;
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
        {
          ...payload,
          mode: 'feedback',
          sub_mode: 'delete_feedback',
          feedback_id: DeletePayload.feedback_id,
        }, config
      );

      toast.success('Feedback Deleted successfully!');
      setEditModalOpen(false);
      setTimeout(() => {
        fetchDataTeacherFeedBack();
      }, 3000);

      // Optionally refresh data, reset fields, etc.
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message ||
        'Failed to delete feedback. Please try again.',
      );
    } finally {
      toggledeleteModal();
    }
  };

  const handleDeleterow = (data) => {
    setDeletePayload(data);
    toggledeleteModal();
  };

  // // console.log("data", milestooneFeedback);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (modalOpen) {
      // Reset fields when closing modal
      setNatureOfFeedback('');
      setScore('');
      setTiming('');
      setDescription('');
      setFormErrors({
        natureOfFeedback: '',
        score: '',
        timing: '',
        description: '',
      });
    }
  };

  // validation
  const [formErrors, setFormErrors] = useState({
    natureOfFeedback: '',
    score: '',
    timing: '',
    description: '',
  });

  const getTimingOptions = () => {
    if (natureOfFeedback === 'Grading' && assesmentFeedback) {
      return assesmentFeedback.map((item) => item.toString()); // Assessment feedback for Grading
    }
    if (natureOfFeedback === 'Compliance' && milestooneFeedback) {
      return milestooneFeedback.map((item) => item.toString()); // Milestone feedback for Complaints
    }
    if (
      natureOfFeedback === 'Student / University Complaint' &&
      milestooneFeedback
    ) {
      return milestooneFeedback.map((item) => item.toString()); // Milestone feedback for Complaints
    }
    if (natureOfFeedback === 'Communication' && milestooneFeedback) {
      return milestooneFeedback.map((item) => item.toString()); // Milestone feedback for Complaints
    }

    return []; // No timing options for other feedback types
  };

  const [appliedFilters, setAppliedFilters] = useState({
    universities: new Set(),
    timelines: new Set(),
    terms: new Set(),
    units: new Set(),
    teachers: new Set(),
    programs: new Set(),
  });

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setdeleteModalOpen] = useState(false);
  const [editNatureOfFeedback, setEditNatureOfFeedback] = useState('');
  const [editFeedback_id, seteditFeedback_id] = useState('');
  const [editTiming, setEditTiming] = useState('');
  const [editDescription, setEditDescription] = useState('');
  const [editScore, setEditScore] = useState('');
  const [editFormErrors, setEditFormErrors] = useState({});
  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
  };

  const [DeletePayload, setDeletePayload] = useState(null);
  const toggledeleteModal = () => {
    if (deleteModalOpen) setDeletePayload(null);
    setdeleteModalOpen(!deleteModalOpen);
  };

  const getEditTimingOptions = () => {
    // This should be based on editNatureOfFeedback or actual data
    return editNatureOfFeedback === 'Grading'
      ? ['1', '2', '3'] // sample assessments
      : ['Milestone 1', 'Milestone 2']; // sample milestones
  };

  const handleEditSubmit = async () => {
    const errors = {};
    if (!editFeedback_id) return;
    if (!editNatureOfFeedback) errors.editNatureOfFeedback = 'Required';
    if (!editTiming) errors.editTiming = 'Required';
    if (!editDescription) errors.editDescription = 'Required';
    if (
      editNatureOfFeedback === 'Grading' &&
      (!editScore || Number(editScore) < 0)
    ) {
      errors.editScore = 'Score must be 0 or greater';
    }

    setEditFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    try {
      const feedbackpayload = {
        nature_of_feedback: editNatureOfFeedback,
        timing: editTiming,
        description: editDescription,
        feedback_id: editFeedback_id,
        score: editNatureOfFeedback === 'Grading' ? editScore : null,
        mode: 'feedback',
        sub_mode: 'update_feedback',
      };

      // Replace with your actual API endpoint
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
        { ...payload, ...feedbackpayload },config
      );

      toast.success('Feedback updated successfully!');
      setEditModalOpen(false);
      setTimeout(() => {
        fetchDataTeacherFeedBack();
      }, 3000);

      // Optionally refresh data, reset fields, etc.
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message ||
        'Failed to update feedback. Please try again.',
      );
    }
  };
  useEffect(() => {
    if (!editModalOpen) {
      setEditNatureOfFeedback('');
      setEditTiming('');
      setEditDescription('');
      setEditScore('');
      setEditFormErrors({});
    }
  }, [editModalOpen]);

  const handleSubmit = async () => {
    setFormErrors({
      natureOfFeedback: '',
      score: '',
      timing: '',
      description: '',
    });
    let hasError = false;

    // Validation
    if (!natureOfFeedback) {
      setFormErrors((prev) => ({
        ...prev,
        natureOfFeedback: 'Nature of Feedback is required.',
      }));
    }
    // if (
    //   (natureOfFeedback === "Grading" || natureOfFeedback === "Student / University Complaint") &&
    //   !score
    // )
    if (natureOfFeedback === 'Grading' && !score) {
      setFormErrors((prev) => ({
        ...prev,
        score: 'Score is required for Grading or Complaints.',
      }));
    }
    if (!timing) {
      setFormErrors((prev) => ({ ...prev, timing: 'Timing is required.' }));
    }
    if (!description) {
      setFormErrors((prev) => ({
        ...prev,
        description: 'Description is required.',
      }));
    }

    if (
      !natureOfFeedback ||
      (natureOfFeedback === 'Grading' && !score) ||
      !timing ||
      !description
    ) {
      return;
    }

    // Prepare payload
    const payload = {
      university:
        appliedUniversities?.size > 0
          ? Array.from(appliedUniversities)
          : Deatilsofteacher?.appliedUniversities
            ? Array.from(Deatilsofteacher.appliedUniversities)
            : null,
      year:
        appliedTimelines?.size > 0
          ? Array.from(appliedTimelines)
          : Deatilsofteacher?.appliedTimelines
            ? Array.from(Deatilsofteacher.appliedTimelines)
            : null,
      term:
        appliedTerms?.size > 0
          ? Array.from(appliedTerms)
          : Deatilsofteacher?.appliedTerms
            ? Array.from(Deatilsofteacher.appliedTerms)
            : null,
      unit_id:
        appliedUnit?.size > 0
          ? Array.from(appliedUnit)
          : Deatilsofteacher?.unit_id
            ? [Deatilsofteacher.unit_id]
            : null,
      teacher_id:
        appliedTeacher?.size > 0
          ? parseInt(Array.from(appliedTeacher)[0])
          : Deatilsofteacher?.teacherid
            ? parseInt(Deatilsofteacher.teacherid)
            : null,
      program:
        appliedPrograms?.size > 0
          ? Array.from(appliedPrograms)
          : Deatilsofteacher?.appliedPrograms
            ? Array.from(Deatilsofteacher.appliedPrograms)
            : null,
      mode: 'feedback',
      sub_mode: 'put_feedback',
      timing: parseInt(timing, 10),

      score: natureOfFeedback === 'Grading' ? parseFloat(score) : 0, // Default score for other types
      nature_of_feedback: natureOfFeedback,
      description,
    };

    if (!appliedTeacher?.size && !Deatilsofteacher?.teacherid) {
      toast.error('Teacher selection is required or Select All Filters.');
      hasError = true;
    }
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
        payload,
        config
      );
      // toast.success('Feedback Added Successfully');

      const newRow = {
        id: rows.length + 1,
        SNo: (rows.length + 1).toString(),
        date: new Date().toLocaleDateString(),
        NatureofFeedback: natureOfFeedback,
        Timing: timing,
        Description: description,
        // Scores: natureOfFeedback === "Grading" || natureOfFeedback === "Student / University Complaint" ? score : 0,
        Scores: natureOfFeedback === 'Grading' ? score : 0,
      };

      setRows([...rows, newRow]);
      toggleModal();
      toast.success('Feedback Added Successfully'); // Correct toast for success
      // console.log('responsefeedback', response);
    } catch (error) {
      toast.error('Invalid or Error while Submitting Feedback');
    }

    setNatureOfFeedback('');
    setScore('');
    setTiming('');
    setDescription('');
    setModalOpen(false);

    // setAppliedUniversities(new Set(appliedUniversities));
    // setAppliedTimelines(new Set(appliedTimelines));
    // setAppliedTerms(new Set(appliedTerms));
    // setAppliedUnit(new Set(appliedUnit));
    // setAppliedTeacher(new Set(appliedTeacher));
    // setAppliedProgram(new Set(appliedPrograms));

    // handleApply();
    // Update the state with all applied filters
    setAppliedFilters((prev) => ({
      ...prev,
      universities: new Set(appliedUniversities),
      timelines: new Set(appliedTimelines),
      terms: new Set(appliedTerms),
      units: new Set(appliedUnit),
      teachers: new Set(appliedTeacher),
      programs: new Set(appliedPrograms),
    }));
  };

  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };

  const toggleProgramDropdown = () => {
    setProgramDropdownOpen((prev) => !prev);
  };

  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const toggleTeacherDropdown = () => {
    setTeacherDropdownOpen((prev) => !prev);
  };

  const togglestausDropdown = () => {
    setStatusDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);

  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const isTeacherSelected = (selectedTeacher) =>
    selectedTeachers.has(selectedTeacher);

  const isTeacherUnitSelected = (teacher_id, unit_id, selectedTeachers, selectedUnits) =>
    selectedTeachers?.has(teacher_id) && selectedUnits?.has(unit_id);

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
    setSelectedUnits,
  ) => {
    let newSelection = new Set(selectedSet);

    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    } else if (
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod' ||
      item.removename === 'removeunits' 
      
    ) {
      // If the item is part of year or study period (single selection)
      newSelection.clear(); // Clear all previous selections
      // newSelection.delete(item.id);
      newSelection.add(item.id); // Add the new selection
    } else if (
      item.removename === 'removeteacher'
    ) {
      newSelection.clear(); 
      newSelection.add(item.id); 
      setSelectedUnits(new Set([item.unit_id]))
    }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      // setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setTimelineProgram([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      // setTimelineUnit([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      // setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      // setTimelineUnit([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
      // setSelectedUnits(new Set());
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
      // setTimelineUnit([]);
    } else if (item.removename === 'removestudyperiod') {
      // setSelectedUnits(new Set());
      // setTimelineUnit([]);
      setSelectedTeachers(new Set());
      setTimelineTeacher([]);
    }
    // else if (item.removename === 'removeunits') {
    //   setSelectedTeachers(new Set());
    //   setTimelineTeacher([]);
    // }

    setSelectedSet(newSelection);
    toggleDropdown();
  };

  const handleApply1 = () => {
    setAppliedStatus(new Set(selectedStatus)); // Save the selected status as applied
    saveToSessionStorage('appliedstatus', selectedStatus);
  };

  const handleApply = () => {
    if (selectedTeachers.size === 0) {
      toast.error('select all filters');
    }

    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedUnit(new Set(selectedUnits));
    setAppliedTeacher(new Set(selectedTeachers));
    setAppliedProgram(new Set(selectedPrograms));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelines', selectedTimelines);
    saveToSessionStorage('appliedTerms', selectedTerms);
    saveToSessionStorage('appliedUnit', selectedUnits);
    saveToSessionStorage('appliedTeacher', selectedTeachers);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('selectedUniversities', selectedUniversities);
    saveToSessionStorage('selectedTimelines', selectedTimelines);
    saveToSessionStorage('selectedPrograms', selectedPrograms);
    saveToSessionStorage('selectedUnits', selectedUnits);
    saveToSessionStorage('selectedTeachers', selectedTeachers);
    saveToSessionStorage('selectedTerms', selectedTerms);

    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setUnitDropdownOpen(false);
    setTimelineTeacher(false);
    fetchTeacher();
  };

  // auto gen code start

  const [webinarStatusDropdownOpen, setWebinarStatusDropdownOpen] =
    useState(false);
  const [webinarStatusSearch, setWebinarStatusSearch] = useState('');
  const [selectedWebinarStatus, setSelectedWebinarStatus] = useState(new Set());
  const [appliedWebinarStatus, setAppliedWebinarStatus] = useState(new Set()); // This will be passed to WebinarGridTable

  const webinarFilterSummaryRef = useRef(null);
  const [showWebinarScrollButtons, setShowWebinarScrollButtons] =
    useState(false);
  const [isWebinarDragging, setIsWebinarDragging] = useState(false);
  const [webinarStartX, setWebinarStartX] = useState(0);
  const [webinarScrollLeft, setWebinarScrollLeft] = useState(0);

  // Derived state for 'Clear All' button
  const hasWebinarSelections = selectedWebinarStatus.size > 0;

  // Webinar-specific dropdown toggle
  const toggleWebinarStatusDropdown = () =>
    setWebinarStatusDropdownOpen(!webinarStatusDropdownOpen);

  // Webinar-specific search handler
  const handleWebinarSearchChange = (e, type) => {
    const value = e.target.value;
    setWebinarStatusSearch(value);
    // Add filtering logic here if you have dynamic status options
  };

  // Webinar-specific select item handler
  const handleWebinarSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    setSelectedSet((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(item.name)) {
        newSet.delete(item.name);
      } else {
        newSet.add(item.name);
      }
      return newSet;
    });
  };

  // Webinar-specific apply handler
  const handleWebinarApply = () => {
    setAppliedWebinarStatus(new Set(selectedWebinarStatus));
    setWebinarStatusDropdownOpen(false); // Close dropdown after applying
  };

  // Webinar-specific clear all handler
  const clearAllWebinarSelections = () => {
    setSelectedWebinarStatus(new Set());
    setAppliedWebinarStatus(new Set());
    setWebinarStatusSearch('');
    // You might also want to close the dropdown if it's open
    setWebinarStatusDropdownOpen(false);
  };

  // Webinar-specific scroll handlers (similar to your existing ones)
  const handleWebinarLeftClick = () => {
    if (webinarFilterSummaryRef.current) {
      webinarFilterSummaryRef.current.scrollBy({
        left: -200,
        behavior: 'smooth',
      });
    }
  };

  const handleWebinarRightClick = () => {
    if (webinarFilterSummaryRef.current) {
      webinarFilterSummaryRef.current.scrollBy({
        left: 200,
        behavior: 'smooth',
      });
    }
  };

  const startWebinarDrag = (e) => {
    setIsWebinarDragging(true);
    setWebinarStartX(
      e.pageX ||
      e.touches[0].pageX - webinarFilterSummaryRef.current.offsetLeft,
    );
    setWebinarScrollLeft(webinarFilterSummaryRef.current.scrollLeft);
  };

  const handleWebinarMouseMove = (e) => {
    if (!isWebinarDragging) return;
    e.preventDefault();
    const x =
      e.pageX ||
      e.touches[0].pageX - webinarFilterSummaryRef.current.offsetLeft;
    const walk = (x - webinarStartX) * 1; // You can adjust the scroll speed
    webinarFilterSummaryRef.current.scrollLeft = webinarScrollLeft - walk;
  };

  const stopWebinarDrag = () => {
    setIsWebinarDragging(false);
  };

  // Effect to show/hide scroll buttons based on overflow for webinars
  useEffect(() => {
    const checkScrollButtons = () => {
      if (webinarFilterSummaryRef.current) {
        const { scrollWidth, clientWidth } = webinarFilterSummaryRef.current;
        setShowWebinarScrollButtons(scrollWidth > clientWidth);
      }
    };

    checkScrollButtons();
    window.addEventListener('resize', checkScrollButtons);
    return () => window.removeEventListener('resize', checkScrollButtons);
  }, [selectedWebinarStatus]); // Re-check when selected status changes

  // auto gen code end

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('home');

  // Function to handle tab change
  // const toggleTab = (tab) => {
  //   setActiveTab(tab);
  // };

    // Set by a chart click; cleared on manual tab change
  const [drillWeek, setDrillWeek] = useState(null);
  const [drillSubTab, setDrillSubTab] = useState(null);

  console.log(drillWeek,"drillWeek");
  
  const toggleTab = (tab) => {
    setActiveTab(tab);
    setDrillWeek(null);
    setDrillSubTab(null);
  };



  const tabsRef = useRef(null);

// const goToTab = (tab) => {
//   toggleTab(tab);

const goToTab = (tab, week = null, subTab = null) => {

  console.log('[goToTab] Teacher ', tab, week, subTab);
  setActiveTab(tab);
  setDrillWeek(week);
  setDrillSubTab(subTab);
  setTimeout(
    () => tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
    50,
  );
};

const chartNav = (options, tab, subTab = null) =>
  
  withChartNavigation(options, (pt) =>
    goToTab(tab, weekNumberFromCategory(pt.category ), subTab),
  );


  // const chartNav = (options, tab, subTab = null) =>
  // withChartNavigation(options, (pt) =>
  //   goToTab(tab, weekNumberFromCategory(pt.category), subTab),
  // );

// Names can differ in case/spacing between the two APIs, so normalize first
const normalizeName = (name) =>
  (name || '').toLowerCase().replace(/\s+/g, ' ').trim();

// Open a student's profile from the flagged-students table
const handleFlaggedStudentClick = ({ studentName }) => {
  const target = normalizeName(studentName);

  const matches = (studentList || []).filter(
    (s) => normalizeName(s.full_name) === target,
  );

  if (matches.length === 0) {
    toast.error(`Could not find "${studentName}" in the Student List.`);
    return;
  }
  if (matches.length > 1) {
    toast.error(
      `More than one student is named "${studentName}". Please open them from the Student List.`,
    );
    return;
  }

  const student = matches[0];

  navigate('/individualteacher/studentDetails', {
    state: {
      StudentName: student.full_name,
      Studentid: student.student, // real student id, not student_classroom_id
      appliedUniversities:
        (appliedUniversities.size > 0 && appliedUniversities) ||
        Deatilsofteacher?.appliedUniversities,
      appliedPrograms:
        (appliedPrograms.size > 0 && appliedPrograms) ||
        Deatilsofteacher?.appliedPrograms,
      appliedTimelines:
        (appliedTimelines.size > 0 && appliedTimelines) ||
        Deatilsofteacher?.appliedTimelines,
      appliedTerms:
        (appliedTerms.size > 0 && appliedTerms) ||
        Deatilsofteacher?.appliedTerms,
      appliedUnit:
        (appliedUnit.size > 0 && appliedUnit) ||
        (Deatilsofteacher?.unit_id
          ? new Set([Deatilsofteacher.unit_id])
          : new Set()),
      appliedTeacher:
        (appliedTeacher.size > 0 && appliedTeacher) ||
        (Deatilsofteacher?.teacherid
          ? new Set([Deatilsofteacher.teacherid])
          : new Set()),
    },
  });
};
  // State to manage the active tab

  // useEffect(() => {
  //   // update params in url like ?activeTab=Call Perfomance
  // }, [activeTab])
  const [searchParams, setSearchParams] = useSearchParams(); // Get searchParams object and setter

  // Effect to update URL search params when activeTab changes
  useEffect(() => {
    // Create a new URLSearchParams object based on current search params
    const newSearchParams = new URLSearchParams(searchParams.toString());

    // Set or update the 'activeTab' parameter
    newSearchParams.set('activeTab', activeTab);

    // Update the URL without causing a full page reload
    setSearchParams(newSearchParams);

    // You can also add a console log to see the effect
    // console.log(`URL updated: ?activeTab=${activeTab}`);
  }, [activeTab, searchParams, setSearchParams]); // Dependencies: activeTab, and the searchParams utilities

  useEffect(() => {
    const tabFromUrl = searchParams.get('activeTab');
    if (tabFromUrl && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, []); // Run only once on mount to read initial URL state

  // Extract performance data safely with fallback
  const positive = chartsData?.positive
    ? parseFloat(chartsData.positive) || 0
    : 0;
  const negative = chartsData?.negative
    ? parseFloat(chartsData.negative) || 0
    : 0;
  const neutral = chartsData?.neutral ? parseFloat(chartsData.neutral) || 0 : 0;

  // Options for Donut Chart 1
  const donutOptions1 = {
    chart: {
      type: 'pie',
    },
    title: {
      text: null,
    },
    plotOptions: {
      pie: {
        innerSize: '90%',
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.percentage:.1f} %',
        },
      },
    },
    series: [
      {
        name: 'Data',
        data: [
          {
            name: 'Positive',
            y: positive,
            color: {
              linearGradient: { x1: 1, y1: 0, x2: 0, y2: 1 }, // Diagonal gradient
              stops: [
                [0, '#F6FFFA'], // Start color
                [0.5, '#E0FDE7'],
                [1, '#BCFACB'], // End color
              ],
            },
          },
          {
            name: 'Negative',
            y: negative,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Diagonal gradient
              stops: [
                [0, '#FFF7F5'], // Start color
                [0.5, '#FCDEDE'],
                [1, '#FEB7BB'], // End color
              ],
            },
          },
          {
            name: 'Neutral',
            y: neutral,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Diagonal gradient
              stops: [
                [0, '#FFF6ED'], // Start color
                [0.5, '#FFEAD9'],
                [1, '#F9CB9A'], // End color
              ],
            },
          },
        ],
      },
    ],

    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: 'Performance Analysis', // Add the title only when exporting
        },
      },
    },
  };

  //call quality milestone
  const [callQualityScoreChartOptions, setCallQualityScoreChartOptions] =
    useState({
      chart: {
        type: 'column', // Column chart type
      },
      title: {
        text: '', // Default chart title
      },
      xAxis: {
        categories: [], // This will be updated dynamically with Milestones
        title: {
          text: 'Milestones', // Label for the x-axis
        },
        labels: {
          style: {
            fontSize: '14px', // Style the labels on the x-axis
            fontWeight: 'bold', // Make the x-axis labels bold
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Quality Score', // Label for the y-axis
          align: 'high',
        },
        labels: {
          overflow: 'justify', // Allow overflow of labels
          style: {
            fontSize: '12px', // Style the y-axis labels
          },
        },
      },
      series: [
        {
          name: 'Quality Score',
          data: [], // This will be updated dynamically with quality scores
          pointWidth: 10, // Set the column width
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from bottom to top
            stops: [
              [0, '#F6F9FF'], // Start color (light blue)
              [1, '#C3D5F9'], // End color (darker blue)
            ],
          },
          dataLabels: {
            enabled: true, // Enable data labels
            inside: true, // Place labels inside the bars
            style: {
              color: 'black', // Label color
              fontWeight: 'bold', // Font weight for labels
              textOutline: 'none', // Remove text outline for clarity
            },
            format: '{point.y}', // Display the value of the data point (Quality Score)
          },
        },
      ],
      credits: {
        enabled: false, // Disable watermark
      },
      exporting: {
        enabled: true, // Enable exporting
        buttons: {
          contextButton: {
            menuItems: [
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
            ], // Enable export buttons
          },
        },
        chartOptions: {
          title: {
            text: 'Call Quality Scores by Milestone (Exported)', // Add title when exporting
          },
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Show data labels for columns
            format: '{point.y}', // Display the value of the data point (Quality Score)
          },
        },
      },
    });

  const teacherTalktime = avgcallData?.teacher_talktime
    ? parseFloat(avgcallData.teacher_talktime) || 0
    : 0;
  const studentTalktime = avgcallData?.student_talktime
    ? parseFloat(avgcallData.student_talktime) || 0
    : 0;
  // Options for Pie Chart
  const pieOptions = {
    chart: {
      type: 'pie',
    },
    title: {
      text: null,
    },

    series: [
      {
        name: 'Data',
        data: [
          {
            name: 'Teacher',
            y: teacherTalktime,
            color: {
              linearGradient: { x1: 1, y1: 0, x2: 0, y2: 1 }, // Diagonal gradient
              stops: [
                [0, '#B7D1F6'], // Start color
                [0.5, '#C3D7FC'],
                [1, '#B7D1F6'], // End color
              ],
            },
          },
          {
            name: 'Student',
            y: studentTalktime,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Diagonal gradient
              stops: [
                [0, '#FEB7BB'], // Start color
                [0.5, '#FDD5D5'],
                [1, '#FEB7BB'], // End color
              ],
            },
          },
        ],
      },
    ],

    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: 'Split of Student Sessions', // Add the title only when exporting
        },
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.y} ({point.percentage:.1f}%)', // Format to show count and percentage
        },
      },
    },
  };

  const weeks = callduration ? Object.keys(callduration) : []; // Get weeks
  const durations = callduration ? Object.values(callduration) : []; // Get corresponding durations
  // Options for Line Chart
  const lineChartOptions = {
    colors: ['#ABC5FF', '#ABC5FF'], // Shades of blue for the line chart
    title: {
      text: null,
    },
    xAxis: {
      categories: weeks,
      title: {
        text: 'Weeks', // X Axis label
      },
    },
    yAxis: {
      title: {
        text: 'Average Duration (Mins)', // Y Axis label
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Minutes',
        data: durations,
        type: 'line',
        dataLabels: {
          enabled: true, // Enable data labels
          inside: true, // Position the labels inside the bars
          align: 'right', // Align the label to the end of the bar
          x: -5, // Offset to position slightly before the end of the bar
          y: 0, // Keep the vertical alignment unchanged
          format: '{y}', // Display the Y value
          style: {
            fontSize: '12px', // Customize font size
            color: '#000', // Customize font color
          },
        },
      },
    ],
    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: ' 1-1 Session Duration ', // Add the title only when exporting
        },
      },
    },
  };

  const [engagementLineChartdata, setengagementLineChartData] = useState({
    weeks: [],
    oneononeengaged: [],
    phone_engaged: [],
  });
  const engagementLineChartOptions = {
    colors: ['#ABC5FF', '#FFABC5'], // Different colors for each line
    title: {
      text: '',
    },
    xAxis: {
      categories: engagementLineChartdata.weeks || [], // X-axis categories
      title: {
        text: 'Weeks', // X Axis label
      },
    },
    yAxis: {
      title: {
        text: '% Students Engaged in 1-1 Sessions', // Y Axis label
      },
      min: 0, // Minimum value
      max:
        Math.max(
          ...engagementLineChartdata.oneononeengaged.map(
            (item) => parseInt(item) || 0,
          ),
          ...engagementLineChartdata.phone_engaged,
        ) + 10,
      labels: {
        formatter: function () {
          return this.value + '%'; // Append % symbol to Y-axis labels
        },
      },
    },
    series: [
      {
        name: 'Total Engaged',
        data: engagementLineChartdata.oneononeengaged || [],
        type: 'line',
        dataLabels: {
          enabled: true, // Enable data labels
          formatter: function () {
            return this.y + '%'; // Append % symbol to data labels
          },
        },
      },
      {
        name: 'Engaged in 1-1 Sessions',
        data: engagementLineChartdata.phone_engaged || [],
        type: 'line',
        dataLabels: {
          enabled: true, // Enable data labels
          formatter: function () {
            return this.y + '%'; // Append % symbol to data labels
          },
        },
      },
    ],
    tooltip: {
      shared: true, // Show tooltips for all series
      crosshairs: true, // Add crosshairs
      pointFormatter: function () {
        return `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y}%</b><br/>`;
      },
    },
    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: 'Students Engaged by Week',
        },
      },
    },
    legend: {
      enabled: true, // Enable legend
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500, // Adjust for smaller screens
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  };


  const within_1_hr = responsive?.within_1_hr
    ? parseFloat(responsive.within_1_hr) || 0
    : 0;
  const between_1_and_2_hrs = responsive?.between_1_and_2_hrs
    ? parseFloat(responsive.between_1_and_2_hrs) || 0
    : 0;
  const between_2_and_6_hrs = responsive?.between_2_and_6_hrs
    ? parseFloat(responsive.between_2_and_6_hrs) || 0
    : 0;
  const above_6_hours = responsive?.above_6_hours
    ? parseFloat(responsive.above_6_hours) || 0
    : 0;
  const not_responded = responsive?.not_responded
    ? parseFloat(responsive.not_responded) || 0
    : 0;

  // Options for Spline Area Chart
  const donutChartOptions = {
    chart: {
      type: 'pie', // Keep it as a pie chart, we will make it a donut using innerSize
      backgroundColor: 'transparent', // Optional: Set background to transparent
      options3d: {
        enabled: true, // Enable 3D effect for donut
        alpha: 45, // Tilt angle for the 3D view
        beta: 0, // Rotation angle for the 3D view
      },
    },
    title: {
      text: null, // No title for the chart
    },
    tooltip: {
      pointFormat: '{point.name}: <b>{point.y}</b> ', // Show value and percentage
    },
    plotOptions: {
      pie: {
        innerSize: '90%', // Increase inner size to create the donut effect
        dataLabels: {
          enabled: false,
          formatter: function () {
            // Only render labels for the first point to avoid duplication
            if (this.point.index === 0) {
              return this.series.data
                .map((point) => `${point.name}: ${point.y}%`)
                .join('<br>');
            }
            return null; // Skip for other points
          },
          style: {
            fontWeight: 'bold',
            color: 'black',
            textAlign: 'center',
          },
          distance: -150, // Increase space between labels and the chart
          connectorWidth: 1, // Draw a line connecting labels to chart
          crop: false, // Prevent labels from being cropped
          // overflow: "allow", // Allow labels to overflow outside the chart
        },
        size: '80%',
        startAngle: -90, // Start angle for semi-circle
        endAngle: 90, // End angle for semi-circle
        center: ['50%', '75%'], // Center the donut chart
        borderWidth: 0, // Remove border
      },
    },
    series: [
      {
        name: ' Message Responsiveness',
        data: [
          {
            name: 'Within 60 min',
            y: within_1_hr,
            color: {
              linearGradient: { x1: 1, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, '#E0FDE7'],
                [1, '#E0FDE7'],
              ],
            },
          },
          {
            name: 'In 1-2 hrs',
            y: between_1_and_2_hrs,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
              stops: [
                [0, '#DBDBFB'],
                [1, '#DBDBFB'],
              ],
            },
          },
          // {
          //   name: "In 2-4 hrs",
          //   y: between_2_and_4_hrs,
          //   color: {
          //     linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          //     stops: [
          //       [0, "#FFEAD9"],
          //       [1, "#FFEAD9"],
          //     ],
          //   },
          // },
          {
            name: 'In 2-6 hrs',
            y: between_2_and_6_hrs,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [1, '#F2F5FC'],
              ],
            },
          },
          {
            name: 'In More than 6 hrs',
            y: above_6_hours,
            color: {
              linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
              stops: [
                [0, '#E6EEFF'],
                [1, '#9397FF'],
              ],
            },
          },
          {
            name: 'Not Responded',
            y: not_responded,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
              stops: [
                [0, '#FFD2D2'],
                [1, '#F79496'],
              ],
            },
          },
        ],
      },
    ],
    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: ' Message Responsiveness', // Title for exported chart
        },
      },
    },
  };


  const [studentReengagementChart, setStudentReengagementChart] = useState({
    
    Weeks: [], // Store weeks separately
  
  });


  const [Groupsessionbyweek, setGroupsessionbyweek] = useState({
    weeks: [],
    duration: [],
    count: [],

  });

  const Groupsessionbyweekchart = {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: Groupsessionbyweek.weeks,
      title: {
        text: 'Weeks',
      },
    },
    yAxis: [
      {
        title: {
          text: 'Number of webinars',
        },
        min: 0,
        opposite: false, // Left axis
        allowDecimals: true,
      },
      {
        title: {
          text: 'Total duration (mins)',
        },
        min: 0,
        opposite: true, // Right axis
        allowDecimals: true,
      },
    ],

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const index = this.points?.[0]?.point.index;
        const week = Groupsessionbyweek.weeks[index] || '';

        let tooltipContent = `<b>Week:</b> ${week}<br/>`;

        this.points.forEach((point) => {
          tooltipContent += `<span style="color:${point.color}">\u25CF</span> 
          <b>${point.series.name}:</b> ${point.y}<br/>`;
        });

        return tooltipContent;
      }
    },
    series: [
      {
        name: 'Number of webinars',
        type: 'line',
        color: '#F9C890',
        data: Groupsessionbyweek.count.map((x) => parseInt(x) || 0),
        yAxis: 0,
        dataLabels: { enabled: true },
      },
      {
        name: 'Total duration (mins)',
        type: 'column',
        data: Groupsessionbyweek.duration.map((x) => parseFloat(x) || 0),
        yAxis: 1,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#F2FFF6'],
            [1, '#BEF8CC'],
          ],
        },
        pointWidth: 10,
        dataLabels: {
          enabled: true,
        },
      },
    ],

    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: '1-1 Session Details, by Week',
        },
      },
    },
  };


  const chartRef = useRef(null);
  const [
    callsAndDurationLineChartOptions,
    setCallsAndDurationLineChartOptions,
  ] = useState(null);
  //group sesssion quality score 
  const [GroupsessionQualitycorce, setGroupsessionQualitycorce] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Avg. Session Quality Score',
      },
      labels: {
        format: '{value}%',
      },
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        fontSize: '12px',
        fontWeight: '500'
      },
    },

    series: [
      {
        name: 'Avg. Session Quality Score',
        data: [],
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'],
            [1, '#B7B8F9'],
          ],
        },
        pointWidth: 10,
      },
    ],
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          format: '{y}%',
          style: {
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Group Session Quality Score',
        },
      },
    },
  });

  // 1-1 session quality audio and video
  const [oneToOneChart, setOneToOneChart] = useState({
    chart: {
      type: "column",
      backgroundColor: "transparent",
      marginTop: 40,
    },
    title: { text: null },
    xAxis: {
      categories: ["Audio", "Video"],
      title: { text: "Session Type" },
    },
    yAxis: {
      min: 0,
      title: { text: "Values" },
    },
    series: [
      {
        name: "Duration of 1-1 sessions",
        type: "column",
        data: [], // Dynamic
        pointWidth: 10,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, "#E1EAF9"],
            [1, "#B5D0FB"],
          ],
        },
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} mins`;
          },
        },
      },
      {
        name: "Number of sessions",
        type: "line",
        data: [], // Dynamic
        color: "#FF9FA2",
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `${this.y} successful`;
          },
        },
      },
    ],
    credits: { enabled: false },
    legend: { enabled: true },
  });


  // State for the bar chart options
  const [messagesBarChartOptions, setMessagesBarChartOptions] = useState({
    chart: {
      type: 'column', // Use 'column' for a vertical grouped bar chart
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [], // X-axis categories
      title: {
        text: 'Weeks', // X Axis label
      },
    },
    yAxis: {
      title: {
        text: 'Number of Messages', // Y Axis label
      },
      min: 0, // Minimum value
    },
    series: [
      {
        name: 'Sent to Student',
        data: [], // Sample data for messages sent
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
          stops: [
            [0, '#F2FFF6'], // Start color
            [1, '#A9FFC2'], // End color
          ],
        },
      },
      {
        name: 'Received from Student',
        data: [], // Sample data for messages received
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
          stops: [
            [0, '#FCF2E6'], // Start color
            [1, '#F8C58C'], // End color
          ],
        },
      },
    ],
    tooltip: {
      shared: true, // Show tooltips for all series
      pointFormat: '{series.name}: <b>{point.y}</b>', // Tooltip formatting
    },
    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: 'Student Messages Exchanged',
        },
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Enable data labels on bars
        },
        pointWidth: 10, // Set the width of the columns
      },
    },
    legend: {
      enabled: true, // Enable legend
    },
  });
  const redFlagsChartOptions = {
    chart: {
      type: 'line', // Use 'line' for a line chart
    },
    title: {
      text: '', // No chart title
    },
    xAxis: {
      categories: callqualityscore ? Object.keys(callqualityscore) : [], // X-axis categories based on the weeks in the response
      title: {
        text: 'Weeks', // X Axis label
      },
    },
    yAxis: {
      title: {
        text: '% 1-1 Sessions', // Y Axis label
      },
      min: 0, // Minimum value
      max: 100, // Max value is capped at 100% since it's a percentage
      labels: {
        format: '{value}%', // Format Y-axis labels to show percentage
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    series: [
      {
        name: 'Red Flags Raised',
        data: callqualityscore ? Object.values(callqualityscore) : [], // Dynamic data from response
        color: '#FF9FA1', // Color for red flags
        dataLabels: {
          enabled: true, // Enable data labels
          format: '{point.y}%', // Show percentage in data labels
          inside: true, // Position the labels inside the bars
          align: 'right', // Align the label to the end of the bar
          x: -5, // Offset to position slightly before the end of the bar
          y: 0, // Keep the vertical alignment unchanged
        },
      },
    ],
    tooltip: {
      shared: true, // Show tooltips for all series
      pointFormat: '{series.name}: <b>{point.y}%</b>', // Tooltip formatting
    },
    credits: {
      enabled: false, // Disable watermark
    },
    exporting: {
      enable: true,
      chartOptions: {
        title: {
          text: '1-1 Sessions With Red Flags',
        },
      },
    },

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500, // Adjust for smaller screens
          },
          chartOptions: {},
        },
      ],
    },
  };

  const [gradingQualityScoreChartOptions, setGradingQualityScoreChartOptions] =
    useState({
      chart: {
        type: 'line', // Use 'line' for a line chart
      },
      title: {
        text: '', // Default title
      },
      xAxis: {
        categories: [], // Will be dynamically populated
        title: {
          text: 'Assessments', // X Axis label
        },
      },
      yAxis: {
        title: {
          text: 'Score', // Y Axis label
        },
        min: 0, // Minimum value (adjust as needed)
        max: 100, // Assuming scores are out of 100
      },
      legend: {
        enabled: false, // Disable the legend (corrected)
      },
      series: [
        {
          name: 'Grading Score',
          data: [], // Data will be dynamically populated
          color: '#A9C6FE', // Color for the line
          dataLabels: {
            enabled: true, // Enable data labels on the chart
          },
        },
      ],
      tooltip: {
        shared: true, // Show tooltips for all series
        pointFormat: '{series.name}: <b>{point.y}</b>', // Tooltip formatting
      },
      credits: {
        enabled: false, // Disable watermark
      },
      exporting: {
        enabled: true, // Enable exporting of the chart
        chartOptions: {
          title: {
            text: 'Grading Quality Score',
          },
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500, // Adjust for smaller screens
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          },
        ],
      },
    });


  //session quality score
  const [chartData, setChartData] = useState({
    milestones: [],
    scores: [],
  });

  useEffect(() => {
    if (callQualityMilestone) {
      const { milestones, avg_session_quality_scores } = callQualityMilestone;

      setChartData({
        milestones,
        scores: avg_session_quality_scores,
      });
    }
  }, [callQualityMilestone]);

  const barChartMilestoneScore = (data) => ({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: null,
    xAxis: {
      categories: data.milestones,
      crosshair: true,
    },
    yAxis: {
      min: 0,
      max: 100,
      title: {
        text: 'Score',
      },
      labels: {
        formatter: function () {
          return this.value;
        },
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          color: 'black',
          style: {
            fontSize: '10px',
            fontWeight: 'bold',
          },
          verticalAlign: 'bottom',
          crop: false,
          overflow: 'none',
        },
      },
    },
    series: [
      {
        name: '1-1 Sessions Quality Score',
        data: data.scores,
        color: {
          linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
          stops: [
            [0, '#E6E4FB'],
            [1, '#B7B8F9'],
          ],
        },
      },
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      pointFormat:
        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: '1-1 Sessions Quality Score',
      },
    },
  });

  //new charts
  const [studenagechart, setStudenageChart] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });

  const clusteredColumnChartOptions = {
    chart: {
      type: 'column', // Column chart
      backgroundColor: 'transparent', // Optional: set background to transparent
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: ['New Students', 'Returning  Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage range from 0 to 100
      tickInterval: 20, // Adjust tick interval as necessary
      title: {
        text: '% Students Engaged', // Y-axis title is percentage
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    labels: {
      formatter: function () {
        return this.value + '%'; // Display percentage on the Y-axis
      },
    },
    plotOptions: {
      column: {
        grouping: true, // Ensure columns are grouped
        borderWidth: 0, // Remove border around columns
        pointWidth: 10, // Set point width to 10
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Set label text color to black
          style: {
            fontSize: '10px', // Set font size for the labels
            fontWeight: 'bold', // Make labels bold
          },
          verticalAlign: 'middle', // Align vertically in the middle
          align: 'left', // Position the labels to the right of the bars
          crop: false, // Ensure labels are visible even if they are outside the plot area
          overflow: 'none', // Do not hide labels that overflow
          x: 10,
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          },
        },
      },
    },
    series: [
      {
        name: ' Student Engagement',
        colorByPoint: true, // Color each column in the series differently
        data: [
          {
            y: parseInt(studenagechart.new) || 0, // New Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(studenagechart.returning) || 0, // Returning Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(studenagechart.total) || 0, // Total Students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
        // pointPlacement: 'on', // Place columns exactly on their category positions
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable chart exporting options
      chartOptions: {
        title: {
          text: 'Students Engaged Till Date',
        },
      },
    },
  };
  //Census Melt Rate (%)  start second chart
  const [censusdropchart, setCensusdropChart] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });

  const clusteredColumnChartOptionsForCensus = {
    chart: {
      type: 'column', // Set chart type to 'column' for grouped bars
      backgroundColor: 'transparent', // Transparent background
    },
    title: {
      text: null, // No chart title
    },
    xAxis: {
      categories: ['New Students', 'Returning Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair for better readability
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage scale from 0 to 100
      tickInterval: 20, // Adjust tick interval as needed
      title: {
        text: 'Melt Rate (%)', // Y-axis title is percentage
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Format labels as percentage
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    plotOptions: {
      column: {
        grouping: true, // Group columns together by category
        borderWidth: 0, // No borders for the columns
        pointWidth: 10, // Width of the columns
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Label text color
          style: {
            fontSize: '10px', // Label font size
            fontWeight: 'bold', // Bold labels
          },
          verticalAlign: 'middle', // Align labels vertically in the middle
          align: 'left', // Position labels to the left of the bars
          crop: false, // Ensure labels are visible even if they overflow
          overflow: 'none', // Do not hide overflowing labels
          x: 10,
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          },
        },
      },
    },
    series: [
      {
        name: 'Census Melt Rate (%)', // Series name
        colorByPoint: true, // Color each column individually
        data: [
          {
            y: parseInt(censusdropchart.new) || 0, // New students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(censusdropchart.returning) || 0, // Returning students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(censusdropchart.total) || 0, // Total students
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable chart exporting options
      chartOptions: {
        title: {
          text: 'Census Melt Rate (%) ', // Title when exporting the chart
        },
      },
    },
  };

  //student satishfaction
  const [studentSatisfactionChartOptions, setStudentSatisfactionChartOptions] =
    useState({
      chart: {
        type: 'column', // Column chart type
        backgroundColor: 'transparent', // Set background to transparent
      },
      title: {
        text: '', // Static title
      },
      xAxis: {
        categories: [], // Will be populated dynamically (weeks)
        title: {
          text: '', // X-axis label
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Average Satisfaction Score', // Y-axis label
        },
        labels: {
          format: '{value}', // Display raw count values (not percentage)
        },
      },
      legend: {
        enabled: false, // Disable the legend
      },
      series: [
        {
          name: 'Mid-Term Satisfaction', // Series for Mid-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#F9C78D'],
              [0.5, '#FFE9D7'],
              [1, '#FFF3E7'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10, // Adjust bar width if necessary
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              return this.y.toFixed(1) + '%'; // Ensure one decimal place
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
        {
          name: 'End-Term Satisfaction', // Series for End-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#A2CCFA'],
              [0.5, '#CEDDFA'],
              [1, '#F2F5FC'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10,
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              // return this.y + '%'; // Show the value with a % symbol
              return this.y.toFixed(1) + '%'; // Ensure one decimal place
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
      ],
      credits: {
        enabled: false, // Disable Highcharts branding
      },
      exporting: {
        enabled: true, // Enable exporting options
        chartOptions: {
          title: {
            text: 'Student Feedback', // Title for the exported chart
          },
        },
      },
    });

  const [unitcompletion, setUnitCompletion] = useState({
    new: '0%',
    returning: '0%',
    total: '0%',
  });
  //unit completion
  const clusteredColumnChartOptionsForUnitCompletion = {
    chart: {
      type: 'column', // Use 'column' for grouped bars
      backgroundColor: 'transparent', // Transparent background
    },
    title: {
      text: null, // No chart title
    },
    xAxis: {
      categories: ['New Students', 'Returning Students', 'All Students'], // Categories for the grouped columns
      title: {
        text: null, // No title for the X-axis
      },
      crosshair: true, // Enable crosshair for better readability
    },
    yAxis: {
      min: 0,
      max: 100, // Percentage scale from 0 to 100
      tickInterval: 20, // Adjust tick interval as needed
      title: {
        text: 'Completion Rate (%)', // Y-axis title as percentage
      },
      labels: {
        formatter: function () {
          return this.value + '%'; // Format labels as percentage
        },
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    plotOptions: {
      column: {
        grouping: true, // Group the columns together by category
        borderWidth: 0, // No borders around columns
        pointWidth: 10, // Width of the columns
        dataLabels: {
          enabled: true, // Enable data labels
          color: 'black', // Label text color
          style: {
            fontSize: '10px', // Label font size
            fontWeight: 'bold', // Bold text for labels
          },
          verticalAlign: 'middle', // Vertically align labels in the middle
          align: 'left', // Align labels to the left of the bars
          crop: false, // Ensure labels are visible even if they overflow
          overflow: 'none', // Do not hide labels that overflow
          x: 10,
          formatter: function () {
            return this.y + '%'; // Append % symbol to the label
          },
        },
      },
    },
    series: [
      {
        name: 'Unit Completion Rate', // Series name
        colorByPoint: true, // Color each column differently
        data: [
          {
            y: parseInt(unitcompletion.new) || 0, // New students' completion rate
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#F9C78D '],
                [0.5, '#FFE9D7'],
                [1, ' #FFF3E7'],
              ],
            },
          },
          {
            y: parseInt(unitcompletion.returning) || 0,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, '#A2CCFA'],
                [0.5, '#CEDDFA'],
                [1, '#F2F5FC'],
              ],
            },
            pointPadding: 0.1,
          },
          {
            y: parseInt(unitcompletion.total) || 0, // Total students

            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, // Vertical gradient
              stops: [
                [0, ' #FF9B9B'],
                [0.5, '#FDD8D8'],
                [1, '#FDE9EB'],
              ],
            },
            pointPadding: 0.1,
          },
        ],
      },
    ],
    credits: {
      enabled: false, // Disable Highcharts branding
    },
    exporting: {
      enabled: true, // Enable exporting options
      chartOptions: {
        title: {
          text: 'Unit Completion Rate', // Title for the exported chart
        },
      },
    },
  };
  // fetch filter
  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log('Sending tabs request with token:', user_token); // 🔍
      // console.log('Payload:', payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log('Tabs Response:', tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };
  const fetchWebinarData = async () => {
    if (!classroom_id) return;

    try {
      // setLoadingFilters(true);
      const response = await axios.post(
        process.env.REACT_APP_API_LINC_FELLOW_BASE_URL + 'webinar/list_webinar',
        {
          // Testing purpose, remove values for actual data
          classroom_id,
        },
      );
      SetwebinarAnalytics(response.data || []);
      console.warn('webinar api linc: ', response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // setLoadingFilters(false);
    }
  };
  const fetchData = async () => {
    try {
      setLoadingFilters(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
    }
  };

  useEffect(() => {
    fetchDataTabs();
    fetchData();
    fetchWebinarData();
  }, []);

  useEffect(() => {
    fetchWebinarData();
  }, [classroom_id]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);

  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineProgram(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  // useEffect(() => {
  //   // Call fetchData only if there are selected universities or timelines
  //   if (
  //     (selectedUniversities && selectedUniversities.size > 0) &&
  //     selectedTimelines.size > 0 &&
  //     selectedTerms > 0
  //   ) {
  //     fetchDatawithYearUnit();
  //   }
  // }, [selectedTimelines, selectedTerms]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

        mode: 'metrics',
        sub_mode: 'year',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedTimelines]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'teacher_report',
        sub_mode: 'term',
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );
      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };


  useEffect(() => {
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchTeacher();
    }
    // fetchTeacher();
  }, [selectedUniversities, selectedTimelines, selectedTerms]);

  const fetchTeacher = async () => {
    setLoading(true);
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        // unit_id: selectedUnits.size > 0 ? Array.from(selectedUnits) : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'teacher_report',
        sub_mode: 'teacher',
      };

      const teacherResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // // Replace old data with new data in the state
      // setTimelineTeacher(
      //   payload.university || payload.year || payload.term || payload.unit_id
      //     ? teacherResponse.teachers || []
      //     : teacherResponse.all_teachers || []
      // );
      setTimelineTeacher(teacherResponse.teachers || []);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  //refresh data for 500 error
  const resetData = () => {
    setResetTrigger((prev) => prev + 1);
    setpayload(null);
    SetflaggedSessionRes([]);
    SetVoiceAnayticsaudio(null);
    SetVoiceAnayticsvideo(null);
    setStudentList([]);
    setCall_performance_response(null);
    setResetTrigger((prev) => prev + 1);
    setwebinarPerfomanceData(null);
    SetwebinarAnalytics(null);
    setSummary(null);
    setTopics(null);
    setQusetions(null);
    setUnitPerformance(null);
    setFeedBackDeatils(null);
    setMilestoneFeedback(null);
    setAssesmentFeedback(null);
    //performance  kpi
    setIndivdualReport(null);
    setIndivdualReportkpicards(null);
    setChartsData(null);
    setAvgCallData(null);
    setCallDuration({});
    setResponsiveness(null);
    setQuailtyRedFLages(null);
    // setCallQualityMilestone();
    setChartData({});
    setStudenageChart({});
    setCensusdropChart({});
    setUnitCompletion({});
    setengagementLineChartData({
      weeks: [],
      oneononeengaged: [],
      phone_engaged: [],
    });
    setStudentReengagementChart({
     
      Weeks: [], // Store weeks separately
    });
    setStudentSatisfactionChartOptions({
      chart: {
        type: 'column', // Column chart type
        backgroundColor: 'transparent', // Set background to transparent
      },
      title: {
        text: '', // Static title
      },
      xAxis: {
        categories: [], // Will be populated dynamically (weeks)
        title: {
          text: '', // X-axis label
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Average Satisfaction Score', // Y-axis label
        },
        labels: {
          format: '{value}', // Display raw count values (not percentage)
        },
      },
      series: [
        {
          name: 'Mid-Term Satisfaction', // Series for Mid-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#F9C78D'],
              [0.5, '#FFE9D7'],
              [1, '#FFF3E7'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10, // Adjust bar width if necessary
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              return this.y + '%'; // Show the value with a % symbol
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
        {
          name: 'End-Term Satisfaction', // Series for End-Term satisfaction
          data: [], // Will be populated dynamically
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, '#A2CCFA'],
              [0.5, '#CEDDFA'],
              [1, '#F2F5FC'],
            ],
          },
          pointPadding: 0.1,
          pointWidth: 10,
          dataLabels: {
            enabled: true, // Enable data labels
            formatter: function () {
              return this.y + '%'; // Show the value with a % symbol
            },
            style: {
              fontSize: '12px', // Customize the font size
              fontWeight: 'bold', // Customize the font weight
              color: 'black', // Customize the font color
            },
          },
        },
      ],
      credits: {
        enabled: false, // Disable Highcharts branding
      },
      exporting: {
        enabled: true, // Enable exporting options
        chartOptions: {
          title: {
            text: 'Student Satisfaction by Week', // Title for the exported chart
          },
        },
      },
    });

    setCallsAndDurationLineChartOptions({
      chart: {
        type: 'line', // Still a line chart
        // You might want to explicitly set a height or width here if not controlled by parent container
        // height: 300,
      },
      colors: ['#7CB5EC', '#FFA3A5'], // Colors for your two series
      title: {
        text: '', // Chart title. Often empty if a higher-level component manages the title.
      },
      xAxis: {
        categories: [], // This will be populated dynamically (e.g., 'weeks' data)
        title: {
          text: 'Weeks', // Title for the X-axis
        },
        labels: {
          // Optional: Add styling for X-axis labels if needed
          // rotation: -45,
        },
      },
      yAxis: [
        {
          // Primary Y-axis for 'Total Successful Calls' (Left Axis)
          title: {
            text: 'No. of Sessions', // Title for the left Y-axis
            style: {
              color: Highcharts.getOptions().colors[0], // Match color to the first series
            },
          },
          labels: {
            format: '{value}', // Format for labels, e.g., '10', '20'
            style: {
              color: Highcharts.getOptions().colors[0], // Match color to the first series
            },
          },
          min: 0, // Ensure axis starts at 0
          opposite: false, // Position on the left
          // Optional: plotLines, gridLineWidth, etc.
        },
        {
          // Secondary Y-axis for 'Total Call Duration' (Right Axis)
          title: {
            text: 'Duration in Hours', // Title for the right Y-axis
            style: {
              color: Highcharts.getOptions().colors[1], // Match color to the second series
            },
          },
          labels: {
            format: '{value} hrs', // Format for labels, e.g., '5 hrs', '10 hrs'
            style: {
              color: Highcharts.getOptions().colors[1], // Match color to the second series
            },
          },
          min: 0, // Ensure axis starts at 0
          opposite: true, // Position on the right
          // Optional: plotLines, gridLineWidth, etc.
        },
      ],
      series: [
        {
          name: 'Total Successful Calls',
          data: [], // This will be populated dynamically (e.g., 'totalCalls' data)
          type: 'line',
          yAxis: 0, // Assign to the first Y-axis (index 0, left)
          dataLabels: {
            enabled: true, // Enable data labels for this series
            // For line charts, Highcharts usually does a good job positioning labels.
            // If you need custom positioning, you might adjust 'y' (vertical offset)
            // y: -10, // Example: move labels 10px above the point
          },
          marker: {
            enabled: true, // Show markers on the line
            radius: 4,
          },
        },
        {
          name: 'Total Call Duration',
          data: [], // This will be populated dynamically (e.g., 'totalDurations' data)
          type: 'line',
          yAxis: 1, // Assign to the second Y-axis (index 1, right)
          dataLabels: {
            enabled: true, // Enable data labels for this series
            // For line charts, 'inside', 'align', 'x', 'y' are less common/effective.
            // Highcharts' default line label positioning is often best.
            // If you need offset, consider 'y' for vertical adjustment.
            // y: 10, // Example: move labels 10px below the point
          },
          marker: {
            enabled: true, // Show markers on the line
            radius: 4,
          },
        },
      ],
      credits: {
        enabled: false, // Disable the Highcharts.com credit
      },
      exporting: {
        enabled: true, // Corrected from 'enable' to 'enabled'
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG', 'downloadCSV', 'downloadXLS'], // Customize export options if needed
          },
        },
        chartOptions: {
          title: {
            text: '1-1 Session Details, by Week', // Title for the exported image/document
            align: 'center', // Align exported title
          },
        },
      },
      plotOptions: {
        // General plot options that apply to all series of a certain type
        line: {
          // You can put common line series options here
          marker: {
            enabled: true, // Ensure markers are enabled for all lines by default
          },
          dataLabels: {
            enabled: true, // Ensure data labels are enabled for all lines by default
          },
          tooltip: {
            valueSuffix: '', // Default suffix, can be overridden by series
          },
        },
        // If you are absolutely sure you will never use 'column' chart type,
        // you can remove this plotOptions.column section.
        // However, if your chart can dynamically change type or has mixed series, keep it.
        column: {
          // Keeping existing column options, though chart type is 'line'
          dataLabels: {
            enabled: true,
          },
          pointWidth: 10,
        },
      },
      tooltip: {
        shared: true, // Show all series data on hover at a single point
        crosshairs: true, // Show crosshairs for easier data reading
      },
      // If you need a legend, ensure it's enabled. It was already in your prev options.
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
      },
    });

    setCallQualityScoreChartOptions({
      chart: {
        type: 'column', // Column chart type
      },
      title: {
        text: '', // Default chart title
      },
      xAxis: {
        categories: [], // This will be updated dynamically with Milestones
        title: {
          text: 'Milestones', // Label for the x-axis
        },
        labels: {
          style: {
            fontSize: '14px', // Style the labels on the x-axis
            fontWeight: 'bold', // Make the x-axis labels bold
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Quality Score', // Label for the y-axis
          align: 'high',
        },
        labels: {
          overflow: 'justify', // Allow overflow of labels
          style: {
            fontSize: '12px', // Style the y-axis labels
          },
        },
      },
      series: [
        {
          name: 'Quality Score',
          data: [], // This will be updated dynamically with quality scores
          pointWidth: 10, // Set the column width
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from bottom to top
            stops: [
              [0, '#F6F9FF'], // Start color (light blue)
              [1, '#C3D5F9'], // End color (darker blue)
            ],
          },
          dataLabels: {
            enabled: true, // Enable data labels
            inside: true, // Place labels inside the bars
            style: {
              color: 'black', // Label color
              fontWeight: 'bold', // Font weight for labels
              textOutline: 'none', // Remove text outline for clarity
            },
            format: '{point.y}', // Display the value of the data point (Quality Score)
          },
        },
      ],
      credits: {
        enabled: false, // Disable watermark
      },
      exporting: {
        enabled: true, // Enable exporting
        buttons: {
          contextButton: {
            menuItems: [
              'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              'downloadSVG',
            ], // Enable export buttons
          },
        },
        chartOptions: {
          title: {
            text: 'Call Quality Scores by Milestone (Exported)', // Add title when exporting
          },
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Show data labels for columns
            format: '{point.y}', // Display the value of the data point (Quality Score)
          },
        },
      },
    });

    setGradingQualityScoreChartOptions({
      chart: {
        type: 'line', // Use 'line' for a line chart
      },
      title: {
        text: '', // Default title
      },
      xAxis: {
        categories: [], // Will be dynamically populated
        title: {
          text: 'Assessment Number', // X Axis label
        },
      },
      yAxis: {
        title: {
          text: 'Score', // Y Axis label
        },
        min: 0, // Minimum value (adjust as needed)
        max: 100, // Assuming scores are out of 100
      },
      legend: {
        enabled: false, // Disable the legend
      },
      series: [
        {
          name: ' Score',
          data: [], // Data will be dynamically populated
          color: '#A9C6FE', // Color for the line
          dataLabels: {
            enabled: true, // Enable data labels on the chart
          },
        },
      ],
      tooltip: {
        shared: true, // Show tooltips for all series
        pointFormat: '{series.name}: <b>{point.y}</b>', // Tooltip formatting
      },
      credits: {
        enabled: false, // Disable watermark
      },
      exporting: {
        enabled: true, // Enable exporting of the chart
        chartOptions: {
          title: {
            text: 'Grading Quality Score',
          },
        },
      },
      legend: {
        enabled: false, // Enable legend
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500, // Adjust for smaller screens
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
              },
            },
          },
        ],
      },
    });
    setLfRedFlagsByCategoryChartOptions({
      chart: {
        type: 'heatmap',
        backgroundColor: 'transparent',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [], // Will be dynamically updated
        title: {
          text: 'Weeks',
        },
      },
      yAxis: {
        categories: [], // Will be dynamically updated
        title: {
          text: '',
        },
      },
      colorAxis: {
        min: 0,
        stops: [
          [0, '#FFFFFF'], // Light for low values
          [0.5, '#BCFACB'], // Yellow for medium values
          [1, '#FFA3A5'], // Red for high values
        ],
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        margin: 0,
        verticalAlign: 'top',
        y: 25,
        symbolHeight: 280,
      },
      series: [], // Will be dynamically updated
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        chartOptions: {
          title: {
            text: 'Compliance Flags',
          },
        },
      },
    });

    setGroupsessionQualitycorce((prev) => ({
      ...prev,
      xAxis: { ...prev.xAxis, categories: [] },
      series: [{ ...prev.series[0], data: [] }],
    }));

    setMessagesBarChartOptions({
      chart: {
        type: 'column', // Use 'column' for a vertical grouped bar chart
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [], // X-axis categories
        title: {
          text: 'Weeks', // X Axis label
        },
      },
      yAxis: {
        title: {
          text: 'Student Messages Exchanged', // Y Axis label
        },
        min: 0, // Minimum value
      },
      series: [
        {
          name: 'Sent to Student',
          data: [], // Sample data for messages sent
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
            stops: [
              [0, '#F2FFF6'], // Start color
              [1, '#A9FFC2'], // End color
            ],
          },
        },
        {
          name: 'Received from Student',
          data: [], // Sample data for messages received
          color: {
            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 }, // Gradient from top to bottom
            stops: [
              [0, '#FCF2E6'], // Start color
              [1, '#F8C58C'], // End color
            ],
          },
        },
      ],
      tooltip: {
        shared: true, // Show tooltips for all series
        pointFormat: '{series.name}: <b>{point.y}</b>', // Tooltip formatting
      },
      credits: {
        enabled: false, // Disable watermark
      },
      exporting: {
        enable: true,
        chartOptions: {
          title: {
            text: 'Student Messages Exchanged',
          },
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true, // Enable data labels on bars
          },
          pointWidth: 10, // Set the width of the columns
        },
      },
      legend: {
        enabled: true, // Enable legend
      },
    });
    setGroupsessionbyweek({
      weeks: [],
      duration: [],
      count: [],

    });
    setOneToOneChart((prev) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: [],
        },
        {
          ...prev.series[1],
          data: [],
        },
      ],
    }));


  };

  const [webinarPerfomanceData, setwebinarPerfomanceData] = useState(null);
  useEffect(() => {
    if (appliedTeacher && appliedTeacher.size > 0) {
      const fetchDataTeacher = async () => {
        const payload = {
          university:
            (appliedUniversities && appliedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null) ||
            (Deatilsofteacher?.appliedUniversities?.size > 0
              ? Array.from(Deatilsofteacher.appliedUniversities)
              : null),

          year:
            (appliedTimelines && appliedTimelines.size > 0
              ? Array.from(appliedTimelines)
              : null) ||
            (Deatilsofteacher?.appliedTimelines?.size > 0
              ? Array.from(Deatilsofteacher.appliedTimelines)
              : null),

          term:
            (appliedTerms && appliedTerms.size > 0
              ? Array.from(appliedTerms)
              : null) ||
            (Deatilsofteacher?.appliedTerms?.size > 0
              ? Array.from(Deatilsofteacher.appliedTerms)
              : null),

          // unit_id:
          //   (appliedUnit && appliedUnit.size > 0
          //     ? Array.from(appliedUnit)
          //     : null) ||
          //   ([Deatilsofteacher?.unit_id || null]

          //    ),

          // teacher_id:
          //   (appliedTeacher && appliedTeacher.size > 0
          //     ? parseInt(Array.from(appliedTeacher)[0])
          //     : null) ||
          //   (Deatilsofteacher?.teacherid
          //     ? parseInt(Deatilsofteacher.teacherid)
          //     : null) ,

          unit_id:
            (appliedUnit && appliedUnit.size > 0
              ? Array.from(appliedUnit)
              : Deatilsofteacher && Deatilsofteacher.unit_id
                ? [Deatilsofteacher.unit_id]
                : null) ||
            (Deatilsofteacher && Deatilsofteacher?.appliedUnit?.size > 0
              ? Array.from(Deatilsofteacher.appliedUnit)
              : null),

          teacher_id:
            appliedTeacher && appliedTeacher.size > 0
              ? parseInt(Array.from(appliedTeacher)[0])
              : Deatilsofteacher && Deatilsofteacher.teacherid
                ? parseInt(Deatilsofteacher.teacherid)
                : Deatilsofteacher?.appliedTeacher?.size > 0
                  ? parseInt(Array.from(Deatilsofteacher.appliedTeacher)[0])
                  : null,

          program:
            (appliedPrograms && appliedPrograms.size > 0
              ? Array.from(appliedPrograms)
              : null) ||
            (Deatilsofteacher?.appliedPrograms?.size > 0
              ? Array.from(Deatilsofteacher.appliedPrograms)
              : null),
        };

        // // console.log("tid",Array.from(appliedTeacher))
        // // console.log("tidwith", payload)
        try {
          setLoading1(true);
          setIsApiLoading(true);

          // const response = await axios.post(
          //   process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
          //   payload,
          // );

          console.warn('Payload being sent:', payload);
          setpayload(payload);
          let config = {
            headers: {
              Authorization: `Token ${user_token}`,
            },
          };
          const [
            response,
            call_performance_response,
            webinar_performance_response,
          ] = await Promise.all([
            axios.post(
              process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
              payload,
              config
            ),
            axios.post(
              process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
              { ...payload, mode: 'call_performance' }, config
            ),
            axios.post(
              process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
              { ...payload, mode: 'webinar_performance' }, config
            ),
          ]);

          setCall_performance_response(call_performance_response);
          setwebinarPerfomanceData(webinar_performance_response);
          //reswponse call quality score
          toast.info(response.message);
          // console.log('response over all data', response);
          setIndivdualReport(response.overall_data);
          setIndivdualReportkpicards(response.cards);
          setChartsData(response.avg_performance);
          setAvgCallData(response.avg_talktime_split);
          setCallDuration(response.avg_duration || {});
          setResponsiveness(response.email_responsiveness);
          // setStudentList(response.student_list);
          setQuailtyRedFLages(response.weekly_call_red_flags);
          const weeklyGroupSessionScore = response?.weekly_group_sessions_quality_score || {};
          setGroupsessionQualitycorce((prev) => ({
            ...prev,
            xAxis: {
              ...prev.xAxis,
              categories: weeklyGroupSessionScore?.weeks || [],
            },
            series: [
              {
                ...prev.series[0],
                data: weeklyGroupSessionScore?.scores?.map(x => parseFloat(x) || 0) || [],
              }
            ],
          }));
          const groupSessionsbyWeek =
            response?.weekly_group_sessions || {};
          setGroupsessionbyweek({
            weeks: groupSessionsbyWeek.weeks,
            duration: groupSessionsbyWeek.duration,
            count: groupSessionsbyWeek.count
          })

          // 1-1 sessition chart audio video
          const oneToOneSession = response?.one_on_one_sessions || {};

          const audioDuration = oneToOneSession?.audio_call_time?.total_duration || 0;
          const videoDuration = oneToOneSession?.video_call_time?.total_duration || 0;

          const audioCount = oneToOneSession?.audio_call_successful_count || 0;
          const videoCount = oneToOneSession?.video_call_successful_count || 0;

          setOneToOneChart((prev) => ({
            ...prev,
            series: [
              {
                ...prev.series[0],
                data: [audioDuration, videoDuration],
              },
              {
                ...prev.series[1],
                data: [audioCount, videoCount],
              },
            ],
          }));
          // setAvgPerformance(response.avg_performance);
          setCallQualityMilestone(response.call_quality_score_by_milestone);
          setStudenageChart(
            response.student_engaged || {
              new: '0%',
              returning: '0%',
              total: '0%',
            },
          );
          setCensusdropChart({
            new: response.census_drop_rate?.new_census || '0%',
            returning: response.census_drop_rate?.return_census || '0%',
            total: response.census_drop_rate?.total_census || '0%',
          });
          setUnitCompletion({
            new: response.unit_completion_rate?.new_unit_rate || '0%',
            returning: response.unit_completion_rate.return_unit_rate || '0%',
            total: response.unit_completion_rate?.total_unit_rate || '0%',
          });
          setengagementLineChartData({
            weeks: response?.student_engagement.weeks || [],
            oneononeengaged:
              response?.student_engagement?.one_on_one_engaged || [],
            phone_engaged: response?.student_engagement?.phone_engaged || [],
          });

          //Student Feedback
          const weeklySatisfactionData =
            response.weekly_student_satisfaction || {};

          setclassroom_id(response?.classroom_id[0]);

          // Extract MID and END satisfaction scores directly
          const categories = ['Mid-Term', 'End-Term'];
          const satisfactionScores = [
            weeklySatisfactionData.MID || 0,
            weeklySatisfactionData.END || 0,
          ];

          // Update chart options
          setStudentSatisfactionChartOptions((prevOptions) => ({
            ...prevOptions, // Keep other chart options intact
            xAxis: {
              ...prevOptions.xAxis,
              categories: categories, // Set categories as Mid-Term and End-Term
            },
            series: [
              {
                name: 'Satisfaction Scores', // Series name
                data: satisfactionScores, // Set satisfaction data dynamically
                color: {
                  linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                  stops: [
                    [0, '#F9C78D'],
                    [0.5, '#FFE9D7'],
                    [1, '#FFF3E7'],
                  ],
                },
                dataLabels: {
                  enabled: true, // Enable data labels
                  formatter: function () {
                    return this.y.toFixed(1); // Ensure one decimal place
                  },
                  style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333', // Adjust label color
                  },
                },
                pointPadding: 0.1,
                pointWidth: 10, // Adjust bar width if necessary
              },
            ],
          }));

          const weeklyData1 = response?.re_engagement_of_active_students;

          setStudentReengagementChart(weeklyData1);

          const weeklyCalls = response.weekly_successful_calls_and_duration;

          // Extract weeks, total calls, and total durations
          const weeks = Object.keys(weeklyCalls); // Get weeks
          const totalCalls = weeks.map(
            (week) => weeklyCalls[week]?.total_calls || 0,
          ); // Get total calls
          const totalDurations = weeks.map(
            (week) => weeklyCalls[week]?.total_duration || 0,
          ); // Get total durations
          const total_duration_str = weeks.map(
            (week) => weeklyCalls[week]?.total_duration_str || 0,
          ); // Get total durations

          setCallsAndDurationLineChartOptions({
            chart: {
              type: 'line', // Use 'line' for a line chart
            },
            colors: ['#7CB5EC', '#FFA3A5'],
            title: {
              text: '', // Empty title within the chart area
            },
            xAxis: {
              categories: weeks, // Directly set the categories from your 'weeks' data
              title: {
                text: 'Weeks',
              },
            },
            yAxis: [
              {
                // Y-axis for 'No. of Sessions' (left)
                title: {
                  text: 'No. of Sessions',
                },
                min: 0,
                opposite: false, // Left Y-axis
              },
              {
                // Y-axis for 'Duration in Hours' (right)
                title: {
                  text: 'Duration in Hours',
                },
                min: 0,
                opposite: true, // Right Y-axis
              },
            ],
            tooltip: {
              shared: true,
              useHTML: true,
              formatter: function () {
                const week = this.x;
                let tooltipContent = `<b>Week:</b> ${week}<br/>`;

                // Use the x value to get the correct index for all arrays
                const index = this.points[0].point.x; // safer than index

                this.points.forEach((point) => {
                  if (point.series.name === 'Total Call Duration') {
                    const durationStr = total_duration_str?.[index] || `${point.y} hrs`;
                    tooltipContent += `<span style="color:${point.color}">\u25CF</span> <b>${point.series.name}:</b> ${durationStr}<br/>`;
                  } else {
                    tooltipContent += `<span style="color:${point.color}">\u25CF</span> <b>${point.series.name}:</b> ${point.y}<br/>`;
                  }
                });

                return tooltipContent;
              },
            },



            series: [
              {
                name: 'Number of 1-1 Sessions',
                data: totalCalls, // Directly set the data from your 'totalCalls'
                type: 'line', // Ensure series type is line
                yAxis: 0, // Assign to the left yAxis
                dataLabels: {
                  enabled: true,
                },
                events: {
                  legendItemClick: function () {
                    const chart = chartRef.current?.chart; // Safely access chart instance
                    if (chart) {
                      const yAxisIndex = this.yAxis.options.index || 0;
                      const yAxis = chart.yAxis[yAxisIndex];
                      const willHide = !this.visible; // Check current visibility before click

                      // Use setTimeout to allow Highcharts to process its visibility change
                      setTimeout(() => {
                        yAxis.update({
                          min: 0, // Ensure min stays 0 even if data changes after hide/show
                          visible: !willHide, // Update yAxis visibility based on series visibility
                          title: { text: !willHide ? 'No. of Sessions' : null }, // Show/hide title
                        });
                      }, 0);
                    }
                  },
                },
              },
              {
                name: '1-1 Sessions Duration',
                data: totalDurations, // Directly set the data from your 'totalDurations'
                type: 'line', // Ensure series type is line
                yAxis: 1, // Assign to the right yAxis
                dataLabels: {
                  enabled: true,
                  inside: true,
                  align: 'right',
                  x: -5,
                  y: 0,
                },
                events: {
                  legendItemClick: function () {
                    const chart = chartRef.current?.chart; // Safely access chart instance
                    if (chart) {
                      const yAxisIndex = this.yAxis.options.index || 1;
                      const yAxis = chart.yAxis[yAxisIndex];
                      const willHide = !this.visible; // Check current visibility before click

                      // Use setTimeout to allow Highcharts to process its visibility change
                      setTimeout(() => {
                        yAxis.update({
                          min: 0, // Ensure min stays 0
                          visible: !willHide, // Update yAxis visibility
                          title: {
                            text: !willHide ? 'Duration in Hours' : null,
                          }, // Show/hide title
                        });
                      }, 0);
                    }
                  },
                },
              },
            ],
            credits: {
              enabled: false,
            },
            exporting: {
              enabled: true,
              chartOptions: {
                title: {
                  text: '1-1 Session Details, by Week', // Title for exported chart
                },
              },
            },
            plotOptions: {
              // If you only have line series, you might only need plotOptions.line
              // If you have mixed series (e.g., column and line), define both
              line: {
                // General options for all line series
                dataLabels: {
                  enabled: true, // This will enable data labels by default for all line series
                },
              },
              // If you had column type charts previously or might in future, keep this:
              column: {
                dataLabels: {
                  enabled: true,
                },
                pointWidth: 10,
              },
            },
            legend: {
              enabled: true,
            },
          });

          //messaage sent and received

          // Extract weekly message data for the bar chart
          const weeklyMessages = response.weekly_messages_sent_and_received;
          const sentMessages = weeklyMessages?.sent || 0; // Messages sent
          const receivedMessages = weeklyMessages?.received || 0; // Messages received
          // Update bar chart with dynamic data
          setMessagesBarChartOptions((prevOptions) => ({
            ...prevOptions,
            xAxis: {
              ...prevOptions.xAxis,
              categories: weeks, // Dynamic weeks
            },
            series: [
              {
                name: 'Sent to Student',
                data: sentMessages, // Sent messages
                color: {
                  linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                  stops: [
                    [0, '#F2FFF6'],
                    [1, '#A9FFC2'],
                  ],
                },
              },
              {
                name: 'Received from Student',
                data: receivedMessages, // Received messages
                color: {
                  linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                  stops: [
                    [0, '#FCF2E6'],
                    [1, '#F8C58C'],
                  ],
                },
              },
            ],
          }));
          // Extract call quality score data by milestone
          const callQualityScores =
            response.call_quality_score_by_milestone || {};

          // Prepare data for the chart
          const milestones = Object.keys(callQualityScores); // Get the milestones (e.g., "Milestone 1")
          const scores = Object.values(callQualityScores); // Get the corresponding scores (e.g., 62)

          // Update the chart options dynamically
          setCallQualityScoreChartOptions((prevOptions) => ({
            ...prevOptions,
            xAxis: {
              ...prevOptions.xAxis,
              categories: milestones, // Set dynamic milestones as categories
            },
            series: [
              {
                ...prevOptions.series[0],
                data: scores, // Set dynamic scores as data
              },
            ],
          }));
          //assesment grading qulity scorec
          // Get the grading quality scores from the API response
          const gradingScoresData =
            response.grading_quality_score_by_assessment || {}; // Ensure data is present

          // Prepare the categories (assessment names) and data (scores)
          const assessments = Object.keys(gradingScoresData); // ["Assessment 1", "Assessment 2", ...]
          const grades = Object.values(gradingScoresData); // [85.53, 91.83, ...]

          // Update the chart options with the dynamic data
          setGradingQualityScoreChartOptions((prevOptions) => ({
            ...prevOptions,
            xAxis: {
              ...prevOptions.xAxis,
              categories: assessments, // Set dynamic assessments as categories
            },

            series: [
              {
                ...prevOptions.series[0],
                data: grades, // Set dynamic scores as data
              },
            ],
          }));

          //Compliance Flags chart
          // Restructure the red flags data for heatmap
          const redFlagsByCategory = response.red_flags_by_category || {};
          const redFlagWeeks = redFlagsByCategory.weeks || []; // Weeks
          const categoriesData = redFlagsByCategory.data || {}; // Category data

          // Convert the data to heatmap format
          const heatmapData = [];
          Object.keys(categoriesData).forEach((category, categoryIndex) => {
            categoriesData[category].forEach((value, weekIndex) => {
              heatmapData.push([weekIndex, categoryIndex, value]); // [x, y, value]
            });
          });

          if (!heatmapData.length || !redFlagWeeks.length) {
            // Fallback for no data
            setLfRedFlagsByCategoryChartOptions({
              chart: {
                type: 'heatmap',
                backgroundColor: 'transparent',
              },
              title: {
                text: '',
              },
              xAxis: {
                categories: ['No Data'], // Placeholder for x-axis
                title: {
                  text: 'Weeks',
                },
              },
              yAxis: {
                categories: ['No Data'], // Placeholder for y-axis
                title: {
                  text: '',
                },
              },
              colorAxis: {
                min: 0,
                stops: [
                  [0, '#FFFFFF'], // Light color for placeholder
                  [0.5, '#E0E0E0'], // Neutral gray
                  [1, '#E0E0E0'], // Neutral gray
                ],
              },
              legend: {
                enabled: false, // Hide legend when no data
              },
              series: [
                {
                  name: 'No Data',
                  borderWidth: 1,
                  borderColor: '#fff',
                  data: [[0, 0, 0]], // Placeholder single cell
                  dataLabels: {
                    enabled: true,
                    color: '#000000',
                    format: 'No Data',
                  },
                },
              ],
              credits: {
                enabled: false,
              },
              exporting: {
                enabled: true,
                chartOptions: {
                  title: {
                    text: 'Compliance Flags',
                  },
                },
              },
            });
          } else {
            // Populate the chart with valid data
            setLfRedFlagsByCategoryChartOptions({
              chart: {
                type: 'heatmap',
                backgroundColor: 'transparent',
              },
              title: {
                text: '',
              },
              xAxis: {
                categories: redFlagWeeks, // Dynamic weeks
                title: {
                  text: 'Weeks',
                },
              },
              yAxis: {
                categories: Object.keys(categoriesData), // Dynamic categories
                title: {
                  text: '',
                },
              },
              colorAxis: {
                min: 0,
                stops: [
                  [0, '#FFFFFF'], // Light for low values
                  [0.5, '#BCFACB'], // Yellow for medium values
                  [1, '#FFA3A5'], // Red for high values
                ],
              },
              legend: {
                align: 'right',
                layout: 'vertical',
                margin: 0,
                verticalAlign: 'top',
                y: 25,
                symbolHeight: 280,
              },
              series: [
                {
                  name: 'Red Flags',
                  borderWidth: 1,
                  borderColor: '#fff',
                  data: heatmapData, // Dynamic heatmap data
                  dataLabels: {
                    enabled: true,
                    color: '#000000',
                  },
                },
              ],
              credits: {
                enabled: false,
              },
              exporting: {
                enabled: true,
                chartOptions: {
                  title: {
                    text: 'Compliance Flags',
                  },
                },
              },
            });
          }

          if (response.status === 500) {
            resetData();
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          resetData();
        } finally {
          setLoading1(false); // Set loading to false after fetching
          setIsApiLoading(false);
        }
      };

      fetchDataTeacher();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedPrograms,
  ]);
  //student list
  useEffect(() => {
    if (appliedTeacher && appliedTeacher.size > 0) {
      const fetchDataTeacherStudentlist = async () => {
        const payload = {
          university:
            (appliedUniversities && appliedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null) ||
            (Deatilsofteacher?.appliedUniversities?.size > 0
              ? Array.from(Deatilsofteacher.appliedUniversities)
              : null),

          year:
            (appliedTimelines && appliedTimelines.size > 0
              ? Array.from(appliedTimelines)
              : null) ||
            (Deatilsofteacher?.appliedTimelines?.size > 0
              ? Array.from(Deatilsofteacher.appliedTimelines)
              : null),

          term:
            (appliedTerms && appliedTerms.size > 0
              ? Array.from(appliedTerms)
              : null) ||
            (Deatilsofteacher?.appliedTerms?.size > 0
              ? Array.from(Deatilsofteacher.appliedTerms)
              : null),

          unit_id:
            (appliedUnit && appliedUnit.size > 0
              ? Array.from(appliedUnit)
              : Deatilsofteacher && Deatilsofteacher.unit_id
                ? [Deatilsofteacher.unit_id]
                : null) ||
            (Deatilsofteacher && Deatilsofteacher?.appliedUnit?.size > 0
              ? Array.from(Deatilsofteacher.appliedUnit)
              : null),

          teacher_id:
            appliedTeacher && appliedTeacher.size > 0
              ? parseInt(Array.from(appliedTeacher)[0])
              : Deatilsofteacher && Deatilsofteacher.teacherid
                ? parseInt(Deatilsofteacher.teacherid)
                : Deatilsofteacher?.appliedTeacher?.size > 0
                  ? parseInt(Array.from(Deatilsofteacher.appliedTeacher)[0])
                  : null,

          program:
            (appliedPrograms && appliedPrograms.size > 0
              ? Array.from(appliedPrograms)
              : null) ||
            (Deatilsofteacher?.appliedPrograms?.size > 0
              ? Array.from(Deatilsofteacher.appliedPrograms)
              : null),

          mode: 'student_list',
        };

        // // console.log("tid",Array.from(appliedTeacher))
        // // console.log("tidwith", payload)
        let config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };
        try {
          const response = await axios.post(
            process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
            payload,
            config
          );
          //reswponse call quality score
          setStudentList(response.student_list);
          // console.warn()
          if (response === 500) {
            resetData();
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          resetData();
        } finally {
        }
      };

      fetchDataTeacherStudentlist();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedPrograms,
  ]);

  const fetchDataTeacherFeedBack = async () => {
    const payload = {
      university:
        (appliedUniversities && appliedUniversities.size > 0
          ? Array.from(appliedUniversities)
          : null) ||
        (Deatilsofteacher?.appliedUniversities?.size > 0
          ? Array.from(Deatilsofteacher.appliedUniversities)
          : null),

      year:
        (appliedTimelines && appliedTimelines.size > 0
          ? Array.from(appliedTimelines)
          : null) ||
        (Deatilsofteacher?.appliedTimelines?.size > 0
          ? Array.from(Deatilsofteacher.appliedTimelines)
          : null),

      term:
        (appliedTerms && appliedTerms.size > 0
          ? Array.from(appliedTerms)
          : null) ||
        (Deatilsofteacher?.appliedTerms?.size > 0
          ? Array.from(Deatilsofteacher.appliedTerms)
          : null),

      // unit_id:
      //   (appliedUnit && appliedUnit.size > 0
      //     ? Array.from(appliedUnit)
      //     : null) ||
      //   ([Deatilsofteacher?.unit_id || null]

      //   ),

      // teacher_id:
      //   (appliedTeacher && appliedTeacher.size > 0
      //     ? parseInt(Array.from(appliedTeacher)[0])
      //     : null) ||
      //   (Deatilsofteacher?.teacherid
      //     ? parseInt(Deatilsofteacher.teacherid)
      //     : null),

      unit_id:
        (appliedUnit && appliedUnit.size > 0
          ? Array.from(appliedUnit)
          : Deatilsofteacher && Deatilsofteacher.unit_id
            ? [Deatilsofteacher.unit_id]
            : null) ||
        (Deatilsofteacher && Deatilsofteacher?.appliedUnit?.size > 0
          ? Array.from(Deatilsofteacher.appliedUnit)
          : null),

      teacher_id:
        appliedTeacher && appliedTeacher.size > 0
          ? parseInt(Array.from(appliedTeacher)[0])
          : Deatilsofteacher && Deatilsofteacher.teacherid
            ? parseInt(Deatilsofteacher.teacherid)
            : Deatilsofteacher?.appliedTeacher?.size > 0
              ? parseInt(Array.from(Deatilsofteacher.appliedTeacher)[0])
              : null,
      program:
        (appliedPrograms && appliedPrograms.size > 0
          ? Array.from(appliedPrograms)
          : null) ||
        (Deatilsofteacher?.appliedPrograms?.size > 0
          ? Array.from(Deatilsofteacher.appliedPrograms)
          : null),
      mode: 'feedback',
      sub_mode: 'get_feedback',
    };
    try {
      // setLoading(true);
      let config = {
        headers: {
          Authorization: `Token ${user_token}`,
        },
      };
      const response = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
        payload,
        config
      );
      setFeedBackDeatils(response.feedback);
      setMilestoneFeedback(response.milestones);
      setAssesmentFeedback(response.assessments);

      if (response.status === 500) {
        resetData();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      resetData();
    } finally {
      // setLoading(false); // Set loading to false after fetching
    }
  };
  useEffect(() => {
    if (appliedTeacher && appliedTeacher.size > 0) {
      fetchDataTeacherFeedBack();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedPrograms,
    appliedFilters,
  ]);
  useEffect(() => {
    if (appliedTeacher && appliedTeacher.size > 0) {
      const fetchDataTeacherunitperformance = async () => {
        const payload = {
          university:
            (appliedUniversities && appliedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null) ||
            (Deatilsofteacher?.appliedUniversities?.size > 0
              ? Array.from(Deatilsofteacher.appliedUniversities)
              : null),

          year:
            (appliedTimelines && appliedTimelines.size > 0
              ? Array.from(appliedTimelines)
              : null) ||
            (Deatilsofteacher?.appliedTimelines?.size > 0
              ? Array.from(Deatilsofteacher.appliedTimelines)
              : null),

          term:
            (appliedTerms && appliedTerms.size > 0
              ? Array.from(appliedTerms)
              : null) ||
            (Deatilsofteacher?.appliedTerms?.size > 0
              ? Array.from(Deatilsofteacher.appliedTerms)
              : null),

          // unit_id:
          //   (appliedUnit && appliedUnit.size > 0
          //     ? Array.from(appliedUnit)
          //     : null) ||
          //   ([Deatilsofteacher?.unit_id || null]

          //   ),

          // teacher_id:
          //   (appliedTeacher && appliedTeacher.size > 0
          //     ? parseInt(Array.from(appliedTeacher)[0])
          //     : null) ||
          //   (Deatilsofteacher?.teacherid
          //     ? parseInt(Deatilsofteacher.teacherid)
          //     : null),
          unit_id:
            (appliedUnit && appliedUnit.size > 0
              ? Array.from(appliedUnit)
              : Deatilsofteacher && Deatilsofteacher.unit_id
                ? [Deatilsofteacher.unit_id]
                : null) ||
            (Deatilsofteacher && Deatilsofteacher?.appliedUnit?.size > 0
              ? Array.from(Deatilsofteacher.appliedUnit)
              : null),

          teacher_id:
            appliedTeacher && appliedTeacher.size > 0
              ? parseInt(Array.from(appliedTeacher)[0])
              : Deatilsofteacher && Deatilsofteacher.teacherid
                ? parseInt(Deatilsofteacher.teacherid)
                : Deatilsofteacher?.appliedTeacher?.size > 0
                  ? parseInt(Array.from(Deatilsofteacher.appliedTeacher)[0])
                  : null,
          program:
            (appliedPrograms && appliedPrograms.size > 0
              ? Array.from(appliedPrograms)
              : null) ||
            (Deatilsofteacher?.appliedPrograms?.size > 0
              ? Array.from(Deatilsofteacher.appliedPrograms)
              : null),
          mode: 'unit_performance',
        };
        try {
          // setLoading(true);
          let config = {
            headers: {
              Authorization: `Token ${user_token}`,
            },
          };
          const response = await axios.post(
            process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
            payload,
            config
          );
          setUnitPerformance(response.unit_performance);
          if (response === 500) {
            resetData();
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          resetData();
        } finally {
          // setLoading(false); // Set loading to false after fetching
        }
      };

      fetchDataTeacherunitperformance();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedPrograms,
  ]);

  useEffect(() => {
    if (appliedTeacher && appliedTeacher.size > 0) {
      const fetchDataTeacherVoiceAnalytics = async () => {
        const payload = {
          university:
            (appliedUniversities && appliedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null) ||
            (Deatilsofteacher?.appliedUniversities?.size > 0
              ? Array.from(Deatilsofteacher.appliedUniversities)
              : null),

          year:
            (appliedTimelines && appliedTimelines.size > 0
              ? Array.from(appliedTimelines)
              : null) ||
            (Deatilsofteacher?.appliedTimelines?.size > 0
              ? Array.from(Deatilsofteacher.appliedTimelines)
              : null),

          term:
            (appliedTerms && appliedTerms.size > 0
              ? Array.from(appliedTerms)
              : null) ||
            (Deatilsofteacher?.appliedTerms?.size > 0
              ? Array.from(Deatilsofteacher.appliedTerms)
              : null),

          unit_id:
            (appliedUnit && appliedUnit.size > 0
              ? Array.from(appliedUnit)
              : Deatilsofteacher && Deatilsofteacher.unit_id
                ? [Deatilsofteacher.unit_id]
                : null) ||
            (Deatilsofteacher && Deatilsofteacher?.appliedUnit?.size > 0
              ? Array.from(Deatilsofteacher.appliedUnit)
              : null),

          teacher_id:
            appliedTeacher && appliedTeacher.size > 0
              ? parseInt(Array.from(appliedTeacher)[0])
              : Deatilsofteacher && Deatilsofteacher.teacherid
                ? parseInt(Deatilsofteacher.teacherid)
                : Deatilsofteacher?.appliedTeacher?.size > 0
                  ? parseInt(Array.from(Deatilsofteacher.appliedTeacher)[0])
                  : null,
          program:
            (appliedPrograms && appliedPrograms.size > 0
              ? Array.from(appliedPrograms)
              : null) ||
            (Deatilsofteacher?.appliedPrograms?.size > 0
              ? Array.from(Deatilsofteacher.appliedPrograms)
              : null),
          mode: 'voice_analytics',
        };
        try {
          // setLoading(true);
          let config = {
            headers: {
              Authorization: `Token ${user_token}`,
            },
          };
          const response = await axios.post(
            process.env.REACT_APP_API_BASE_URL + 'individual_teacher_report/',
            payload,
            config
          );
          setSummary(response.summary);
          setTopics(response.topics);
          setQusetions(response.questions);
          SetVoiceAnayticsaudio(response.sessions || []);
          SetVoiceAnayticsvideo(response.video_call_list);
          SetflaggedSessionRes(response.flagged_sessions || []);


          if (response === 500) {
            resetData();
          }
          // setMilestoneFeedback(response.milestones)
          // setAssesmentFeedback(response.assessments)
        } catch (error) {
          console.error('Error fetching data:', error);
          resetData();
        } finally {
          // setLoading(false); // Set loading to false after fetching
        }
      };

      fetchDataTeacherVoiceAnalytics();
    }
  }, [
    appliedUniversities,
    appliedTimelines,
    appliedTerms,
    appliedUnit,
    appliedTeacher,
    appliedPrograms,
  ]);

  // sticky filter bar
  const [
    lfRedFlagsByCategoryChartOptions,
    setLfRedFlagsByCategoryChartOptions,
  ] = useState({
    chart: {
      type: 'heatmap',
      backgroundColor: 'transparent',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [], // Will be dynamically updated
      title: {
        text: 'Weeks',
      },
    },
    yAxis: {
      categories: [], // Will be dynamically updated
      title: {
        text: ' ',
      },
    },
    legend: {
      enabled: false, // Disable the legend
    },
    colorAxis: {
      min: 0,
      stops: [
        [0, '#FFFFFF'], // Light for low values
        [0.5, '#BCFACB'], // Yellow for medium values
        [1, '#FFA3A5'], // Red for high values
      ],
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      margin: 0,
      verticalAlign: 'top',
      y: 25,
      symbolHeight: 280,
    },
    series: [], // Will be dynamically updated
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Compliance Flags',
        },
      },
    },
  });
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters

  const [slideIndex, setSlideIndex] = useState(0);

  const [showScrollButtons, setShowScrollButtons] = useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  // const stopDrag = () => {
  //   setIsDragging(false);
  //   filterSummaryRef.current.style.cursor = 'grab';
  //   document.body.style.userSelect = ''; // Re-enable text selection globally
  // };
  const stopDrag = () => {
    setIsDragging(false);

    if (filterSummaryRef.current) {
      filterSummaryRef.current.style.cursor = 'grab';
    }

    document.body.style.userSelect = '';
  };


  const [showScrollButtons1, setShowScrollButtons1] = useState(false);

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [selectedStatus]);

  // Function to handle the left scroll button click
  const handleLeftClick1 = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick1 = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const [isDragging1, setIsDragging1] = useState(false);
  const [startX1, setStartX1] = useState(0);
  const [scrollLeft1, setScrollLeft1] = useState(0);

  // Start dragging (onMouseDown)
  const startDrag1 = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging1(true);
    setStartX1(clientX);
    setScrollLeft1(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove1 = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag1 = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0 ||
    selectedUnits.size > 0 ||
    selectedTeachers.size > 0;
  const hasSelections1 = selectedStatus.size > 0;

  const clearAllSelections = () => {
    setResetTrigger((prev) => prev + 1);

    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    setSelectedUnits(new Set());
    setSelectedTeachers(new Set());
    setSelectedStatus(new Set());
    setTimelineProgram([]);
    setTimelineYears([]);
    setTimelineTerms([]);
    setTimelineUnit([]);
    setTimelineTeacher([]);

    fetchData();
    removeFromSessionStorage('appliedUniversities1');
    removeFromSessionStorage('appliedTimelines');
    removeFromSessionStorage('appliedTerms');
    removeFromSessionStorage('appliedUnit');
    removeFromSessionStorage('appliedPrograms1');
    removeFromSessionStorage('appliedTeacher');

    removeFromSessionStorage('selectedUniversities');
    removeFromSessionStorage('selectedTimelines');
    removeFromSessionStorage('selectedPrograms');
    removeFromSessionStorage('selectedUnits');
    removeFromSessionStorage('selectedTeachers');
    removeFromSessionStorage('selectedTerms');
    removeFromSessionStorage('appliedstatus');
    removeFromSessionStorage('appliedstatus');

    resetData();
  };
  const clearAllSelections1 = () => {
    setSelectedStatus(new Set());

    removeFromSessionStorage('appliedstatus');
    removeFromSessionStorage('appliedstatus');
  };
  const handleSelectItem1 = (item, selectedStatus, setSelectedStatus) => {
    setSelectedStatus((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(item.id)) {
        newSet.delete(item.id);
      } else {
        newSet.add(item.id);
      }

      // console.log('Updated selectedStatus:', newSet); // Correctly logs the new state
      return newSet;
    });
  };

  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          {/* Navigation Bar */}
          <div className={` top-filter ${isSticky ? 'sticky-filter' : ''}`}>
            <div className=" ">
              {/* <div className="tab-tp-title">
                <h3 className="bold">
                  Individual Staff Details
                  {individualReport ? ` - ${individualReport.teacher_name}` : ""}
                  
                </h3>
              </div> */}
              <div className="idt mt-1 d-flex flex-md-row flex-column justify-content-between align-items-xl-center align-items-end  flex-wrap gap-2 mb-2">
                <div className="d-flex  flex-wrap gap-2">
                  {/* University Dropdown */}
                  <Dropdown
                    isOpen={universityDropdownOpen}
                    toggle={toggleUniversityDropdown}
                  >
                    <DropdownToggle
                      className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      {/* University <i className="mdi mdi-chevron-down" /> */}
                      {loadingFilter ? 'Loading' : 'University'}{' '}
                      <i className="mdi mdi=chevron-down" />
                    </DropdownToggle>
                    {!loadingFilter && (
                      <>
                        <DropdownMenu className="p-0">
                          <input
                            type="text"
                            placeholder="Search Universities"
                            className="form-control"
                            value={universitySearch}
                            onChange={(e) =>
                              handleSearchChange(e, 'university')
                            }
                          />
                          {/* "Select All" Option */}
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation();
                              const allSelected =
                                selectedUniversities.size ===
                                universities.length;
                              const newSelection = new Set();

                              if (!allSelected) {
                                // Select all universities
                                universities.forEach((university) =>
                                  newSelection.add(university.id),
                                );
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setTimelineProgram([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedUnits(new Set());
                                setSelectedTeachers(new Set());
                                setTimelineUnit([]);
                                setTimelineTeacher([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                              } else {
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setTimelineProgram([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setSelectedUnits(new Set());
                                setSelectedTeachers(new Set());
                                setTimelineUnit([]);
                                setTimelineTeacher([]);
                                setTimelineYears([]);
                                setTimelineTerms([]);
                              }

                              setSelectedUniversities(newSelection); // Update the selected universities set
                              toggleUniversityDropdown(); // Close the dropdown
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  selectedUniversities.size ===
                                  universities.length
                                } // Check if all are selected
                                readOnly
                              />
                              <label className="form-check-label">All</label>
                            </div>
                          </DropdownItem>

                          {/* University Options */}
                          {/* {universities.map((university) => ( */}
                          {filterUniversities(universitySearch).map(
                            (university) => (
                              <DropdownItem
                                key={university.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(
                                    {
                                      id: university.id,
                                      name: university.university_name,
                                      removename: 'removeuniversity',
                                    },
                                    selectedUniversities,
                                    setSelectedUniversities,
                                    toggleUniversityDropdown,
                                    true, // Pass true to reset other filters (year, term, unit, teacher)
                                  );
                                }}
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isItemSelected(
                                      university.id,
                                      selectedUniversities,
                                    )}
                                    readOnly
                                  />
                                  <label className="form-check-label">
                                    {university.university_name}
                                  </label>
                                </div>
                              </DropdownItem>
                            ),
                          )}

                          {/* ))} */}
                        </DropdownMenu>
                      </>
                    )}
                  </Dropdown>
                  <Dropdown
                    isOpen={programDropdownOpen}
                    toggle={toggleProgramDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineProgram.length === 0}
                      className={`btn program-bg ${timelineProgram.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Programs <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Programs"
                        className="form-control"
                        value={programSearch}
                        onChange={(e) => handleSearchChange(e, 'program')}
                      />
                      {/* All Option */}
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          const allSelected =
                            selectedPrograms.size === timelineProgram.length;
                          const newSelection = new Set();
                          if (!allSelected) {
                            timelineProgram.forEach(([programId]) =>
                              newSelection.add(programId),
                            );
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedUnits(new Set());
                            setSelectedTeachers(new Set());
                            setTimelineUnit([]);
                            setTimelineTeacher([]);
                            setTimelineYears([]);
                            setTimelineTerms([]);
                          } else {
                            //deselect
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setSelectedUnits(new Set());
                            setSelectedTeachers(new Set());
                            setTimelineUnit([]);
                            setTimelineTeacher([]);
                            setTimelineYears([]);
                            setTimelineTerms([]);
                          }
                          setSelectedPrograms(newSelection);
                          toggleProgramDropdown();
                        }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              selectedPrograms.size === timelineProgram.length
                            }
                            readOnly
                          />
                          <label className="form-check-label">All</label>
                        </div>
                      </DropdownItem>
                      {/* {timelineProgram.map((program) => {
                        const [programId, programName] = program;  // Destructure the ID and name from the array
                        return ( */}
                      {filterPrograms(programSearch).map(
                        ([programId, programName]) => (
                          <DropdownItem
                            key={programId} // Use the programId as the key
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: programId,
                                  name: programName,
                                  removename: 'removeprograms',
                                },
                                selectedPrograms,
                                setSelectedPrograms,
                                toggleProgramDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  programId,
                                  selectedPrograms,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">
                                {programName}
                              </label>
                            </div>
                          </DropdownItem>
                        ),
                      )}

                      {/* );
                      })} */}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <div className="d-flex   justify-content-end flex-wrap gap-2">
                  {/* Timeline Dropdown */}
                  <Dropdown
                    isOpen={timelineDropdownOpen}
                    toggle={toggleTimelineDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineYears.length === 0}
                      className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Year <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Year"
                        className="form-control"
                        value={timelineSearch}
                        onChange={(e) => handleSearchChange(e, 'timeline')}
                      />

                      {/* {timelineYears.map((year, index) => ( */}
                      {filterTimeline(timelineSearch).map((year, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: year,
                                name: year,
                                removename: 'removeyears',
                              },
                              selectedTimelines,
                              setSelectedTimelines,
                              toggleTimelineDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isItemSelected(year, selectedTimelines)}
                              readOnly
                            />
                            <label className="form-check-label">{year}</label>
                          </div>
                        </DropdownItem>
                      ))}

                      {/* ))} */}
                    </DropdownMenu>
                  </Dropdown>

                  {/* Timeline Term Dropdown */}
                  <Dropdown
                    isOpen={termDropdownOpen}
                    toggle={toggleTermDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTerms.length === 0}
                      className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Study Period <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Study Period"
                        className="form-control"
                        value={termSearch}
                        onChange={(e) => handleSearchChange(e, 'term')}
                      />
                      {/* {timelineTerms.map((term, index) => ( */}
                      {filterTerms(termSearch).map((term, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: term,
                                name: term,
                                removename: 'removestudyperiod',
                              },
                              selectedTerms,
                              setSelectedTerms,
                              toggleTermDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTermSelected(term, selectedTerms)}
                              readOnly
                            />
                            <label className="form-check-label">{term}</label>
                          </div>
                        </DropdownItem>
                      ))}

                      {/* ))} */}
                    </DropdownMenu>
                  </Dropdown>

                  {/* <Dropdown isOpen={unitDropdownOpen} toggle={toggleUnitDropdown}>
                    <DropdownToggle
                      className={`btn units-bg ${timelineUnit.length > 0 ? '' : ' disable'}`}
                      caret
                      style={{ color: "#656565" }}
                    >
                      Units <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0"> */}
                  {/* Search Box */}
                  {/* <input
                        type="text"
                        placeholder="Search Units"
                        className="form-control"
                        value={unitSearch}
                        onChange={(e) => handleSearchChange(e, 'unit')}
                      /> */}
                  {/* {timelineUnit.map((unit) => ( */}
                  {/* {filterUnits(unitSearch).map((unit) => (
                        <DropdownItem
                          key={unit.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleSelectItem({ id: unit.id, name: unit.name }, selectedUnits, setSelectedUnit, toggleUnitDropdown);
                            handleSelectItem(
                              { id: unit.id, name: unit.name, removename: 'removeunits' },
                              selectedUnits,
                              setSelectedUnits,
                              toggleUnitDropdown
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isUnitSelected(unit.id, selectedUnits)}
                              readOnly
                            />
                            <label className="form-check-label">
                              {unit.name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))} */}
                  {/* ))} */}
                  {/* </DropdownMenu>
                  </Dropdown> */}

                  <Dropdown
                    isOpen={teacherDropdownOpen}
                    toggle={toggleTeacherDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTeacher.length === 0}
                      className={`btn teachers-bg ${timelineTeacher.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Teachers <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Teachers"
                        className="form-control"
                        value={teacherSearch}
                        onChange={(e) => handleSearchChange(e, 'teacher')}
                      />
                      
                      {filterTeachers(teacherSearch).map((teacher) => (
                        <DropdownItem
                          key={`${teacher.id}__${teacher.unit_id}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: teacher.id,
                                unit_id: teacher.unit_id,
                                name: teacher.full_name,
                                removename: 'removeteacher',
                              },
                              selectedTeachers,
                              setSelectedTeachers,
                              toggleTeacherDropdown,
                              setSelectedUnits,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTeacherUnitSelected(
                                teacher.id,
                                teacher.unit_id,
                                selectedTeachers,
                                selectedUnits
                              )}
                              readOnly
                            />
                            <label className="form-check-label">
                              {teacher.full_name}
                            </label>
                          </div>
                        </DropdownItem>
                      ))}
                     
                    </DropdownMenu>
                  </Dropdown>

                  <button
                    type="button"
                    className="btn btn-primary border-0 py-1 px-3 me-1"
                    onClick={handleApply} // Close dropdowns on apply
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>

            {/* normal nav filter show */}
            <div className="filters-show">
              <div className="selected-filters">
                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-left"
                    onClick={handleLeftClick}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                )}

                <div
                  className="filter-summary"
                  ref={filterSummaryRef}
                  onMouseDown={startDrag}
                  onMouseMove={handleMouseMove}
                  onMouseUp={stopDrag}
                  onMouseLeave={stopDrag}
                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                >
                  {selectedUniversities.size > 0 && (
                    <div
                      className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                        }`}
                    >
                      {Array.from(selectedUniversities).map((universityId) => {
                        const university = universities.find(
                          (u) => u.id === universityId,
                        );
                        return university ? (
                          <p
                            key={universityId}
                            className="filter-tag university"
                          >
                            {university.university_name}{' '}
                            {/* <i
                              className="ri-close-line"
                              style={{ cursor: "pointer" }}
                              onClick={() => removeUniversity(universityId)}
                            ></i> */}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedPrograms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedPrograms).map((programId) => {
                        const program = timelineProgram.find(
                          ([id]) => id === programId,
                        );
                        return program ? (
                          <p key={programId} className="filter-tag programs">
                            {program[1]}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTimelines.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTimelines).map((year, index) => (
                        <p key={index} className="filter-tag year">
                          {year}
                        </p>
                      ))}
                    </div>
                  )}

                  {selectedTerms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTerms).map((term, index) => (
                        <p key={index} className="filter-tag stu-period">
                          {term}
                        </p>
                      ))}
                    </div>
                  )}

                  {/* Display selected units */}
                  {selectedUnits.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedUnits).map((unitId) => {
                        const unit = timelineUnit.find((u) => u.id === unitId);
                        return unit ? (
                          <p key={unitId} className="filter-tag units">
                            {unit.name}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTeachers.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTeachers).map((teacherId) => {
                        // Check if timelineTeacher is an array before using find()
                        if (Array.isArray(timelineTeacher)) {
                          const teacher = timelineTeacher.find(
                            (t) => t.id === teacherId,
                          );
                          return teacher ? (
                            <p key={teacherId} className="filter-tag teachers">
                              {teacher.full_name}
                            </p>
                          ) : null;
                        } else {
                          console.error(
                            'timelineTeacher is not an array:',
                            timelineTeacher,
                          );
                          return null;
                        }
                      })}
                    </div>
                  )}
                </div>

                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-right"
                    onClick={handleRightClick}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                )}
              </div>

              <div className="">
                {hasSelections && (
                  <button
                    type="button"
                    className="clear-all-btn me-1"
                    onClick={clearAllSelections}
                  >
                    <i class="ri-close-fill"></i> Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="tab-tp-title">
            <h3 className="bold">
              Individual Staff Details
              {individualReport ? ` - ${individualReport.teacher_name}` : ''}
            </h3>
          </div>

          <div className="mt-1">
            <Card className="mb-2">
              <CardBody>
                {isApiLoading ? ( // Show spinner only when API is loading
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: '200px' }}
                  >
                    <Spinner style={{ width: '3rem', height: '3rem' }} />
                  </div>
                ) : (
                  <>
                    <div className="tab-head d-flex justify-content-between  mb-2">
                      <h5 className="bold">Overview</h5>
                    </div>
                    <div>
                      <Row className="g-2">
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card
                            style={{
                              minHeight: '100px',
                            }}
                            className="minty-gradient border-green mb-0 h-100"
                          >
                            <CardBody>
                              <div>
                                <div className="mb-2">
                                  <p className="f-14 semibold">Current Unit</p>
                                </div>
                                <div
                                  id="unitCard"
                                  className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden"
                                >
                                  <h6 className="f-3 bold">
                                    {individualReport?.unit_deployed || 'N/A'}
                                  </h6>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                          <Tooltip
                            placement="top"
                            isOpen={unitTooltipOpen}
                            target="unitCard"
                            toggle={toggleUnitTooltip}
                          >
                            {getTooltipContent(individualReport?.unit_deployed)}
                          </Tooltip>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="peachy-gradient border-red mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/totalcallduration')} style={{ cursor: 'pointer' }} > */}
                          <Card
                            style={{
                              minHeight: '100px',
                            }}
                            className="peachy-gradient border-red mb-0 h-100 "
                          >
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Active Students
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {individualReport
                                      ? individualReport.active_students
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          <Card
                            style={{
                              minHeight: '100px',
                            }}
                            className="lavender-gradient border-lavender mb-0 h-100"
                          >
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Total Units Delivered
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {individualReport
                                      ? individualReport.units_delivered
                                      : '0'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col xxl={2} xl={3} lg={4} sm={6}>
                          {/* <Card className="blush-gradient border-red mb-0 h-100 ex-link" onClick={() => handleCardClick('/dashboard/responedcalls')} style={{ cursor: 'pointer' }}> */}
                          <Card
                            style={{
                              minHeight: '100px',
                            }}
                            className="peach-blossom-gradient border-yellow mb-0 h-100 "
                          >
                            <CardBody>
                              <div className="">
                                <div className="mb-2">
                                  <p className="f-14 semibold">
                                    Performance Category{' '}
                                  </p>
                                </div>

                                <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                  <h4 className="bold">
                                    {individualReport
                                      ? individualReport.teacher_category ===
                                        null
                                        ? 'N/A'
                                        : individualReport.teacher_category ||
                                        'N/A'
                                      : 'N/A'}
                                  </h4>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>


                      </Row>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </div>

          {/* <NestedTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}

          <div ref={tabsRef} style={{ scrollMarginTop: 90 }}>
  {/* <NestedTabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}

  <NestedTabs activeTab={activeTab} setActiveTab={toggleTab} />
</div>

          {activeTab === 'home' && (
            <div>
              <Card className="mb-2" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  <div>
                    <div
                      className="border"
                      style={{ padding: '16px', borderRadius: '8px' }}
                    >
                      {/*row2*/}
                      <Row className="g-2 mt-2">
                        {isApiLoading ? ( // Show loader while loading
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            <Spinner
                              style={{ width: '3rem', height: '3rem' }}
                            />
                          </div>
                        ) : (
                          <>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100"
                                style={{
                                  minHeight: '100px',
                                }}
                              >
                                <CardBody>
                                  <div>
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        % Student Engaged
                                      </p>
                                    </div>
                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="f-3 bold">
                                        {individualReport?.student_engaged || 'N/A'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100 ex-link"
                                // onClick={handleSuccessfulcalls}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Weekly Student Engagement
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.average_percentage_of_students_engaged
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>



                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="peachy-gradient border-red mb-0 h-100"
                                style={{
                                  minHeight: '100px',
                                }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        % Students Engaged via 1-1 Sessions
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReport
                                          ? individualReport.students_engaged_one_on_one_sessions
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>

                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="peachy-gradient border-red mb-0 h-100 "
                                // onClick={handleRedFlagNavigate}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Weekly Student Engagement via 1-1 Sessions
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.average_percentage_of_students_engaged_in_sessions
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="sky-gradient border-sky mb-0 h-100 ex-link"
                                style={{ cursor: 'pointer', minHeight: '100px' }}
                              >
                                <CardBody>
                                  <div>
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Total 1:1 Session Duration
                                      </p>
                                    </div>
                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReport?.total_duration || '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card className="sky-gradient border-sky mb-0 h-100">
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        {/* Average Session Duration */}
                                        Avg. 1-1 Session Duration (Min)
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.average_duration_by_session
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100 ex-link"
                                // onClick={handleSuccessfulcalls}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Avg. Time Spent in 1-1 Sessions Per Student (Mins)
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.average_duration_by_student
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100 ex-link"
                                // onClick={handleSuccessfulcalls}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        1-1 Sessions Quality Score
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.average_session_quality_score
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="peachy-gradient border-red mb-0 h-100 "
                                // onClick={handleRedFlagNavigate}
                                 onClick={() => goToTab(TAB.INSIGHTS, null, 'Student Issues')}
                                //  onClick={() => goToTab(TAB.RED_FLAG)}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        % 1-1 Sessions With Red Flags
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards?.percentage_of_sessions_with_red_flags
                                          ? individualReportKpicards?.percentage_of_sessions_with_red_flags
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card className="sky-gradient border-sky mb-0 h-100">
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Messages Responded Within 60 Mins
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.messages_responded_in_60_mins
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100 ex-link"
                                // onClick={handleSuccessfulcalls}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Group Sessions Quality Score
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.avg_group_session_quality_score
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="peachy-gradient border-red mb-0 h-100 "
                                // onClick={handleRedFlagNavigate}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        % Group Sessions Quality Score &gt; 80
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.percentage_of_group_session_above_80
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="peachy-gradient border-red mb-0 h-100 "
                                // onClick={handleRedFlagNavigate}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Grading Quality Score
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.avg_grading_quality_score
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>



                          </>
                        )}
                      </Row>
                      {/* row3 */}
                      <Row className="g-2 mt-2">
                        {isApiLoading ? ( // Show loader while loading
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: '200px' }}
                          >
                            <Spinner
                              style={{ width: '3rem', height: '3rem' }}
                            />
                          </div>
                        ) : (
                          <>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card className="sky-gradient border-sky mb-0 h-100">
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Compliance Flags Raised
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.compliance_flags_raised
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col xxl={2} xl={3} lg={4} sm={6}>
                              <Card
                                className="minty-gradient border-green mb-0 h-100 ex-link"
                                // onClick={handleSuccessfulcalls}
                                style={{ cursor: 'pointer' }}
                              >
                                <CardBody>
                                  <div className="">
                                    <div className="mb-2">
                                      <p className="f-14 semibold">
                                        Discussion forum score
                                      </p>
                                    </div>

                                    <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                                      <h4 className="bold">
                                        {individualReportKpicards
                                          ? individualReportKpicards.discussion_forum_score
                                          : '0'}
                                      </h4>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>

                             


                          </>
                        )}
                      </Row>
                      {/* row4 */}

                    </div>
                    {/* row5 */}
                    <Row className="g-2 mt-0">
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3 ">
                                Students Engaged Till Date
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={clusteredColumnChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>

                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <PlotBarChart
                              suffix=""
                              title="Student Re-engagement Till Date"
                              yAxisTitle="No of Students Re-engaged"
                              xAxisTitle="Number of Weeks Engaged"
                              barColors={[
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                              ]}
                              options={studentReengagementChart}
                            />
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3 ">
                                Students Engaged by Week
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={engagementLineChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                1-1 Session Details, by Week
                              </h5>

                              <HighchartsReact
                                ref={chartRef}
                                highcharts={Highcharts}
                                options={callsAndDurationLineChartOptions}
                              /> */}


                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
                                  1-1 Session Details, by Week
                                </ChartTitle>
                                <HighchartsReact
                                  ref={chartRef}
                                  highcharts={Highcharts}
                                  options={withChartNavigation(callsAndDurationLineChartOptions, () => goToTab(TAB.ONE_TO_ONE))}
                                />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold d-flex mb-3 ">
                                1-1 Session Duration{' '}
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={lineChartOptions}
                              /> */}

                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Session Duration
</ChartTitle>

<HighchartsReact
  highcharts={Highcharts}
  options={withChartNavigation(lineChartOptions, () => goToTab(TAB.ONE_TO_ONE))}
/>
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className=" mt-lg-2 mt-0">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold mb-3">
                                1-1 Sessions by Type
                              </h5>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={oneToOneChart}
                              /> */}

                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Sessions by Type
</ChartTitle>
<HighchartsReact
  highcharts={Highcharts}
  options={withChartNavigation(oneToOneChart, () => goToTab(TAB.ONE_TO_ONE))}
/>
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="mt-0 mb-lg-0 mb-2">
                        <Card className="mb-lg-0 mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                1-1 Sessions Quality Score
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={barChartMilestoneScore(
                                  chartData,
                                )}
                              /> */}
                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
  1-1 Sessions Quality Score
</ChartTitle>

<HighchartsReact
  highcharts={Highcharts}
  options={withChartNavigation(barChartMilestoneScore(chartData), () => goToTab(TAB.ONE_TO_ONE))}
/>
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className=" mb-2 mt-0 ">
                        <Card className="mb-2 border box-shadow-none h-100">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold d-flex align-items-center mb-3">
                                1-1 Sessions With Red Flags{' '}
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={redFlagsChartOptions}
                              /> */}

                              <ChartTitle onClick={() => goToTab(TAB.INSIGHTS, null, 'Student Issues')} hint="View red flag sessions">
                              {/* <ChartTitle onClick={() => goToTab(TAB.RED_FLAG)} hint="View red flag sessions"> */}
  1-1 Sessions With Red Flags
</ChartTitle>

<HighchartsReact
  highcharts={Highcharts}
  // options={withChartNavigation(redFlagsChartOptions, () => goToTab(TAB.RED_FLAG))}
options={chartNav(redFlagsChartOptions, TAB.INSIGHTS, 'Student Issues')}
/>
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3">
                                Student Messages Exchanged
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={messagesBarChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3">
                                Message Responsiveness
                              </h5>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={donutChartOptions}
                              />
                              <div className="d-flex gap-2 pt-2">
                                <div className="data-card-value dcv-1">
                                  <p className="data-val">
                                    {within_1_hr}%
                                  </p>
                                  <p className="data-label">
                                    Within 60 min
                                  </p>
                                </div>
                                <div className="data-card-value dcv-2">
                                  <p className="data-val">
                                    {between_1_and_2_hrs}%
                                  </p>
                                  <p className="data-label">In 1-2 hrs</p>
                                </div>
                                {/* <div className="data-card-value dcv-5">
                                        <p className="data-val">{between_2_and_4_hrs}%</p>
                                        <p className="data-label">In 2-4 hrs</p>
                                      </div> */}
                              </div>
                              <div className="d-flex gap-2 pt-2">
                                <div className="data-card-value dcv-6">
                                  <p className="data-val">
                                    {between_2_and_6_hrs}%
                                  </p>
                                  <p className="data-label">In 2-6 hrs</p>
                                </div>
                                <div className="data-card-value dcv-4">
                                  <p className="data-val">
                                    {above_6_hours}%
                                  </p>
                                  <p className="data-label">
                                    In More than 6 hrs
                                  </p>
                                </div>
                                <div className="data-card-value dcv-3">
                                  <p className="data-val">
                                    {not_responded}%
                                  </p>
                                  <p className="data-label">
                                    Not Responded
                                  </p>
                                </div>
                              </div>
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className=" mt-lg-2 mt-0">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold mb-3">
                                Group Session Details by Week
                              </h5> */}

                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
Group Session Details by Week
</ChartTitle>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={withChartNavigation(Groupsessionbyweekchart, () => goToTab(TAB.WEBINARS))}
                              />

                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className=" mt-lg-2 mt-0">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              {/* <h5 className="f-16 bold mb-3">
                                Group Session Quality Score
                              </h5> */}
                              <ChartTitle onClick={() => goToTab(TAB.ONE_TO_ONE)} hint="View 1-1 sessions">
Group Session Quality Score
</ChartTitle>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={withChartNavigation(GroupsessionQualitycorce, () => goToTab(TAB.WEBINAR_PERFORMANCE))}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>

                      <Col lg={6} className="mt-0">
                        <Card className="mb-0 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3">
                                Grading Quality Score
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={gradingQualityScoreChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>

                      <Col lg={6} className=" mb-2 mt-0">
                        <Card className="mb-2 border box-shadow-none h-100">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3">
                                Compliance Flags
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={lfRedFlagsByCategoryChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>


                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3 ">
                                Census Melt Rate (%)
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={
                                  clusteredColumnChartOptionsForCensus
                                }
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3 ">
                                Unit Completion Rate
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={
                                  clusteredColumnChartOptionsForUnitCompletion
                                }
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                      <Col lg={6} className="">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold d-flex align-items-center mb-3 ">
                                Student Feedback
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={studentSatisfactionChartOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              {/*new*/}
              {/*section2*/}
              {/* <Card className="mb-2" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  <div>
                    <Row className="g-2 mt-0">

                    </Row>
                  </div>
                </CardBody>
              </Card> */}
              {/* <Card className="mb-2" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  <div>
                    <Row className="g-2 mt-0"> */}


              {/* 
                      <Col lg={6} className="mb-lg-0 mb-2">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5
                             
                                className="f-16 bold d-flex mb-3"

                            
                              >
                                Avg. Performance Analysis{' '}
                               
                              </h5>
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={donutOptions1}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col> */}
              {/* <Col lg={6} className=" mt-lg-2 mt-0">
                        <Card className="mb-2 h-100 border box-shadow-none">
                          {isApiLoading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <CardBody>
                              <h5 className="f-16 bold mb-3">
                                Split of Student Sessions
                              </h5>

                              <HighchartsReact
                                highcharts={Highcharts}
                                options={pieOptions}
                              />
                            </CardBody>
                          )}
                        </Card>
                      </Col> */}

              {/* </Row>
                  </div>
                </CardBody>
              </Card> */}
            </div>
          )}
          {activeTab === 'about' && (
            <div className="mb-3">
              <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  {isApiLoading ? ( // Show spinner only when API is loading
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner style={{ width: '3rem', height: '3rem' }} />
                    </div>
                  ) : (
                    <div className="va-info-wrapper">
                      <h5 className="f-16 bold mb-2">Student List</h5>

                      <StudentTable
                        studentList={studentList}
                        appliedUniversities={
                          (appliedUniversities.size > 0 &&
                            appliedUniversities) ||
                          Deatilsofteacher?.appliedUniversities
                        }
                        appliedPrograms={
                          (appliedPrograms.size > 0 && appliedPrograms) ||
                          Deatilsofteacher?.appliedPrograms
                        }
                        appliedTimelines={
                          (appliedTimelines.size > 0 && appliedTimelines) ||
                          Deatilsofteacher?.appliedTimelines
                        }
                        appliedTerms={
                          (appliedTerms.size > 0 && appliedTerms) ||
                          Deatilsofteacher?.appliedTerms
                        }
                        appliedUnit={
                          (appliedUnit.size > 0 && appliedUnit) ||
                          (Deatilsofteacher?.unit_id
                            ? new Set([Deatilsofteacher.unit_id])
                            : new Set())
                        }
                        appliedTeacher={
                          (appliedTeacher.size > 0 && appliedTeacher) ||
                          (Deatilsofteacher?.teacherid
                            ? new Set([Deatilsofteacher.teacherid])
                            : new Set())
                        }
                      />
                    </div>
                  )}
                </CardBody>
              </Card>
            </div>
          )}
          {activeTab === 'contact' && (
            <div>
              <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  <div>
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-primary border-0 py-1 px-3 me-1"
                        onClick={toggleModal}
                      >
                        Add Feedback
                      </button>
                    </div>
                    <p>
                      {DeletePayload?.NatureofFeedback}
                      <strong>* Note:</strong> The <strong>Timing</strong>{' '}
                      Column Displays:
                      <strong> Milestone #</strong> for Compliance Feedback
                      and
                      <strong> Assessment #</strong> for Grading feedback.
                    </p>

                    <FeedBackTable
                      feedBackDeatils={feedBackDeatils}
                      onEdit={handleEdit}
                      onDelete={handleDeleterow}
                    />
                  </div>

                  <Modal centered isOpen={modalOpen} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>
                      <h5 className="semibold">Add Feedback</h5>
                    </ModalHeader>
                    <Container className="mt-3 mb-3 p-3">
                      <FormGroup>
                        <Label for="natureOfFeedback">
                          Nature of Feedback{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        <Input
                          type="select"
                          id="natureOfFeedback"
                          value={natureOfFeedback}
                          onChange={(e) =>
                            setNatureOfFeedback(e.target.value)
                          }
                          invalid={!!formErrors.natureOfFeedback}
                        >
                          <option value="">Select...</option>
                          <option value="Communication">
                            Communication
                          </option>
                          <option value="Compliance">Compliance</option>
                          <option value="Grading">Grading</option>
                          <option value="Student / University Complaint">
                            Student / University Complaint
                          </option>
                        </Input>
                        {formErrors.natureOfFeedback && (
                          <div className="invalid-feedback">
                            {formErrors.natureOfFeedback}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="timing">
                          {natureOfFeedback === 'Grading'
                            ? 'Enter Assessment # Relevant to this Feedback'
                            : 'Select Milestone # Relevant to this Feedback'}{' '}
                          <span className="mandatory">*</span>
                        </Label>

                        {natureOfFeedback === 'Grading' ? (
                          <Input
                            type="number"
                            id="timing"
                            placeholder="Enter Assessment #"
                            value={timing}
                            // onChange={(e) => setTiming(e.target.value)}
                            // invalid={!!formErrors.timing}
                            // min="1"
                            onChange={(e) => {
                              const value = e.target.value;
                              setTiming(value);

                              if (Number(value) < 1) {
                                setFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  timing:
                                    'Assessment number must be 1 or greater.',
                                }));
                              } else {
                                setFormErrors((prevErrors) => {
                                  const { timing, ...rest } = prevErrors;
                                  return rest;
                                });
                              }
                            }}
                            invalid={!!formErrors.timing}
                          />
                        ) : (
                          <Input
                            type="select"
                            id="timing"
                            value={timing}
                            onChange={(e) => setTiming(e.target.value)}
                            invalid={!!formErrors.timing}
                          >
                            <option value="">Select...</option>
                            {/* {getTimingOptions().map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))} */}
                            {getTimingOptions().length > 0 ? (
                              getTimingOptions().map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))
                            ) : (
                              <option disabled value="">
                                {natureOfFeedback === 'Grading'
                                  ? 'No Assessments Available'
                                  : 'No Milestones Available'}
                              </option>
                            )}
                          </Input>
                        )}
                        {formErrors.timing && (
                          <div className="invalid-feedback">
                            {formErrors.timing}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="description">
                          Provide Detailed Feedback{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        <Input
                          type="textarea"
                          id="description"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          invalid={!!formErrors.description}
                        />
                        {formErrors.description && (
                          <div className="invalid-feedback">
                            {formErrors.description}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="score">
                          Enter Grading Score{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        {natureOfFeedback === 'Grading' ? (
                          // <Input
                          //   type="number"
                          //   step="0.01"
                          //   id="score"
                          //   value={score}
                          //   onChange={(e) => setScore(e.target.value)}
                          //   invalid={!!formErrors.score}
                          // />
                          <Input
                            type="number"
                            step="0.01"
                            id="score"
                            value={score}
                            onChange={(e) => {
                              const value = e.target.value;
                              setScore(value);

                              const num = parseFloat(value); // safer than Number() for decimals
                              let error = '';

                              if (!value || isNaN(num)) {
                                error =
                                  'Score is required and must be a valid number.';
                              } else if (num <= 0) {
                                error = 'Score must be greater than 0.';
                              } else if (num > 100) {
                                error =
                                  'Score must be lesser or equal to 100.';
                              }

                              if (error) {
                                setFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  score: error,
                                }));
                              } else {
                                // Clear score error only
                                setFormErrors((prevErrors) => {
                                  const { score, ...rest } = prevErrors;
                                  return rest;
                                });
                              }
                            }}
                            invalid={!!formErrors.score}
                          />
                        ) : (
                          <Input type="text" value="N/A" readOnly />
                        )}
                        {formErrors.score && (
                          <div className="invalid-feedback">
                            {formErrors.score}
                          </div>
                        )}
                      </FormGroup>
                    </Container>

                    <ModalFooter className="border-0">
                      <Button color="secondary" onClick={toggleModal}>
                        Cancel
                      </Button>
                      <Button color="primary" onClick={handleSubmit}>
                        Submit
                      </Button>
                    </ModalFooter>
                  </Modal>
                  <Modal
                    centered
                    isOpen={deleteModalOpen}
                    toggle={toggledeleteModal}
                  >
                    <ModalHeader toggle={toggledeleteModal}>
                      <h5 className="semibold">Delete Feedback</h5>
                    </ModalHeader>

                    <Container className="p-3 mt-1">
                      Are you sure want to delete this Feedback ?
                    </Container>
                    <ModalFooter className="border-0">
                      <Button color="secondary" onClick={toggledeleteModal}>
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={handleDeleteFeedBack}
                      >
                        Confirm Delete
                      </Button>
                    </ModalFooter>
                  </Modal>
                  <Modal
                    centered
                    isOpen={editModalOpen}
                    toggle={toggleEditModal}
                  >
                    <ModalHeader toggle={toggleEditModal}>
                      <h5 className="semibold">Edit Feedback</h5>
                    </ModalHeader>

                    <Container className="mt-3 mb-3 p-3">
                      <FormGroup>
                        <Label for="editNatureOfFeedback">
                          Nature of Feedback{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        <Input
                          type="select"
                          id="editNatureOfFeedback"
                          value={editNatureOfFeedback}
                          onChange={(e) =>
                            setEditNatureOfFeedback(e.target.value)
                          }
                          invalid={!!editFormErrors.editNatureOfFeedback}
                        >
                          <option value="">Select...</option>
                          <option value="Communication">
                            Communication
                          </option>
                          <option value="Compliance">Compliance</option>
                          <option value="Grading">Grading</option>
                          <option value="Student / University Complaint">
                            Student / University Complaint
                          </option>
                        </Input>
                        {editFormErrors.editNatureOfFeedback && (
                          <div className="invalid-feedback">
                            {editFormErrors.editNatureOfFeedback}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="editTiming">
                          {editNatureOfFeedback === 'Grading'
                            ? 'Enter Assessment # Relevant to this Feedback'
                            : 'Select Milestone # Relevant to this Feedback'}{' '}
                          <span className="mandatory">*</span>
                        </Label>

                        {editNatureOfFeedback === 'Grading' ? (
                          <Input
                            type="number"
                            id="editTiming"
                            placeholder="Enter Assessment #"
                            value={editTiming}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEditTiming(value);

                              if (Number(value) < 1) {
                                setEditFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  editTiming:
                                    'Assessment number must be 1 or greater.',
                                }));
                              } else {
                                setEditFormErrors((prevErrors) => {
                                  const { editTiming, ...rest } =
                                    prevErrors;
                                  return rest;
                                });
                              }
                            }}
                            invalid={!!editFormErrors.editTiming}
                          />
                        ) : (
                          <Input
                            type="select"
                            id="editTiming"
                            value={editTiming}
                            onChange={(e) => setEditTiming(e.target.value)}
                            invalid={!!editFormErrors.editTiming}
                          >
                            <option value="">Select...</option>
                            {/* {getTimingOptions().map((option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ))} */}
                            {getEditTimingOptions().length > 0 ? (
                              getEditTimingOptions().map(
                                (option, index) => (
                                  <option key={index} value={option}>
                                    {option}
                                  </option>
                                ),
                              )
                            ) : (
                              <option disabled value="">
                                {natureOfFeedback === 'Grading'
                                  ? 'No Assessments Available'
                                  : 'No Milestones Available'}
                              </option>
                            )}
                          </Input>
                        )}
                        {editFormErrors.editTiming && (
                          <div className="invalid-feedback">
                            {editFormErrors.editTiming}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="editDescription">
                          Provide Detailed Feedback{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        <Input
                          type="textarea"
                          id="editDescription"
                          value={editDescription}
                          onChange={(e) =>
                            setEditDescription(e.target.value)
                          }
                          invalid={!!editFormErrors.editDescription}
                        />
                        {editFormErrors.editDescription && (
                          <div className="invalid-feedback">
                            {editFormErrors.editDescription}
                          </div>
                        )}
                      </FormGroup>

                      <FormGroup>
                        <Label for="editScore">
                          Enter Grading Score{' '}
                          <span className="mandatory">*</span>
                        </Label>
                        {editNatureOfFeedback === 'Grading' ? (
                          <Input
                            type="number"
                            step="0.01"
                            id="editScore"
                            value={editScore}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEditScore(value);

                              const num = parseFloat(value); // safer than Number() for decimals
                              let error = '';

                              if (!value || isNaN(num)) {
                                error =
                                  'Score is required and must be a valid number.';
                              } else if (num <= 0) {
                                error = 'Score must be greater than 0.';
                              } else if (num > 100) {
                                error =
                                  'Score must be lesser or equal to 100.';
                              }

                              if (error) {
                                setEditFormErrors((prevErrors) => ({
                                  ...prevErrors,
                                  editScore: error,
                                }));
                              } else {
                                setEditFormErrors((prevErrors) => {
                                  const { editScore, ...rest } = prevErrors;
                                  return rest;
                                });
                              }
                            }}
                            invalid={!!editFormErrors.editScore}
                          />
                        ) : (
                          <Input type="text" value="N/A" readOnly />
                        )}
                        {editFormErrors.editScore && (
                          <div className="invalid-feedback">
                            {editFormErrors.editScore}
                          </div>
                        )}
                      </FormGroup>
                    </Container>

                    <ModalFooter className="border-0">
                      <Button color="secondary" onClick={toggleEditModal}>
                        Cancel
                      </Button>
                      <Button color="primary" onClick={handleEditSubmit}>
                        Save Changes
                      </Button>
                    </ModalFooter>
                  </Modal>
                </CardBody>
              </Card>

              {/* <div
                    style={{
                      minHeight: '250px',
                    }}
                  ></div> */}
            </div>
          )}
          {activeTab === 'unitperformace' && (
            <div>
              <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                <CardBody>
                  <div className="va-info-wrapper">
                    <UnitPerfomanceTable
                      UnitPerfomanceTableData={UnitPerfomanceTableData}
                      appliedUniversities={
                        (appliedUniversities.size > 0 &&
                          appliedUniversities) ||
                        Deatilsofteacher?.appliedUniversities
                      }
                      appliedTimelines={
                        (appliedTimelines.size > 0 && appliedTimelines) ||
                        Deatilsofteacher?.appliedTimelines
                      }
                      appliedTerms={
                        (appliedTerms.size > 0 && appliedTerms) ||
                        Deatilsofteacher?.appliedTerms
                      }
                      appliedUnit={
                        (appliedUnit.size > 0 && appliedUnit) ||
                        (Deatilsofteacher?.unit_id
                          ? new Set([Deatilsofteacher.unit_id])
                          : new Set())
                      }
                      appliedTeacher={
                        (appliedTeacher.size > 0 && appliedTeacher) ||
                        (Deatilsofteacher?.teacherid
                          ? new Set([Deatilsofteacher.teacherid])
                          : new Set())
                      }
                    />
                  </div>
                </CardBody>
              </Card>
            </div>
          )}
          {activeTab === 'voice' && (
            <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
              <CardBody>
                <div className="">
                  <h5 className="f-16 bold"> Audio or Video Sessions</h5>
                  <div className="d-flex flex-wrap gap-2">
                    <div className="flex-grow-1">
                      {/* <h5 className="f-16 bold">FAQ</h5> */}
                    </div>
                    <div className="ind-un-re">
                      <div className="d-flex justify-content-end flex-wrap gap-2">
                        <Dropdown
                          isOpen={statusDropdownOpen}
                          toggle={togglestausDropdown}
                        >
                          <DropdownToggle
                            className={`btn stu-period-bg`}
                            caret
                          >
                            Status <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>

                          {/* Prevent dropdown from closing when typing */}
                          <DropdownMenu
                            className="p-0"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <input
                              type="text"
                              placeholder="Search status"
                              className="form-control"
                              value={statusSearch}
                              onChange={(e) =>
                                handleSearchChange(e, 'status')
                              }
                            />

                            {/* Static Items - Successful & Unsuccessful */}
                            {['Successful', 'Unsuccessful'].map(
                              (status, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSelectItem1(
                                      {
                                        id: status,
                                        name: status,
                                        removename: 'removestatus',
                                      },
                                      selectedStatus,
                                      setSelectedStatus,
                                      togglestausDropdown,
                                    );
                                  }}
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={selectedStatus.has(status)}
                                      readOnly
                                    />
                                    <label className="form-check-label">
                                      {status}
                                    </label>
                                  </div>
                                </DropdownItem>
                              ),
                            )}
                          </DropdownMenu>
                        </Dropdown>

                        <button
                          type="button"
                          className="btn btn-primary border-0 py-1 px-3 me-1"
                          onClick={handleApply1}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="filters-show">
                      <div className="selected-filters">
                        {showScrollButtons1 && (
                          <button
                            className="slider-button slider-button-left"
                            onClick={handleLeftClick1}
                          >
                            <i className="ri-arrow-left-s-line"></i>
                          </button>
                        )}

                        <div
                          className="filter-summary"
                          ref={filterSummaryRef}
                          onMouseDown={startDrag1}
                          onMouseMove={handleMouseMove1}
                          onMouseUp={stopDrag1}
                          onMouseLeave={stopDrag1}
                          onTouchStart={startDrag1} // Touch equivalent of onMouseDown
                          onTouchMove={handleMouseMove1} // Touch equivalent of onMouseMove
                          onTouchEnd={stopDrag1} // Touch equivalent of onMouseUp
                        >
                          {selectedStatus.size > 0 && (
                            <div className="filter-item">
                              {Array.from(selectedStatus).map(
                                (ststus, index) => (
                                  <p
                                    key={index}
                                    className="filter-tag mi-stone-type"
                                  >
                                    {ststus}
                                  </p>
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        {showScrollButtons1 && (
                          <button
                            className="slider-button slider-button-right"
                            onClick={handleRightClick1}
                          >
                            <i className="ri-arrow-right-s-line"></i>
                          </button>
                        )}
                      </div>
                      <div className="">
                        {hasSelections1 && (
                          <button
                            type="button"
                            className="clear-all-btn me-1"
                            onClick={clearAllSelections1}
                          >
                            <i class="ri-close-fill"></i> Clear All
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {activeTab === 'voice' && (
                    <div>
                      <Card
                        className="border box-shadow-none mb-0 mt-2"
                        style={{ borderTopLeftRadius: '0' }}
                      >
                        <CardBody>
                          <div className="va-info-wrapper">
                            <AudioTable
                              VoiceAnayticsaudio={VoiceAnayticsaudio}
                              appliedStatus={appliedStatus}
                              appliedUniversities={
                                (appliedUniversities.size > 0 &&
                                  appliedUniversities) ||
                                Deatilsofteacher?.appliedUniversities
                              }
                              appliedPrograms={
                                (appliedPrograms.size > 0 &&
                                  appliedPrograms) ||
                                Deatilsofteacher?.appliedPrograms
                              }
                              appliedTimelines={
                                (appliedTimelines.size > 0 &&
                                  appliedTimelines) ||
                                Deatilsofteacher?.appliedTimelines
                              }
                              appliedTerms={
                                (appliedTerms.size > 0 && appliedTerms) ||
                                Deatilsofteacher?.appliedTerms
                              }
                              appliedUnit={
                                (appliedUnit.size > 0 && appliedUnit) ||
                                (Deatilsofteacher?.unit_id
                                  ? new Set([Deatilsofteacher.unit_id])
                                  : new Set())
                              }
                              appliedTeacher={
                                (appliedTeacher.size > 0 &&
                                  appliedTeacher) ||
                                (Deatilsofteacher?.teacherid
                                  ? new Set([Deatilsofteacher.teacherid])
                                  : new Set())
                              }
                            />
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          )}
          {activeTab === 'Red Flag Sessions' &&
            (flaggedSessionRes ? (
              <Card
                style={{
                  marginBottom: '100px',
                  borderTopLeftRadius: '0',
                  borderRadius: '0',
                }}
              >
                <CardBody>
                  <RedFlagSessionTab data={flaggedSessionRes} />
                </CardBody>
              </Card>
            ) : (
              <Card
                className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                style={{ height: '200px' }}
              >
                No Red-Flag Session Analysis is available
              </Card>
            ))}
          {activeTab === 'Call Performance' && (
            <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
              {Call_performance_response && !isApiLoading ? (
                <div>
                  <Card className="mb-0" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
                    <CardBody className="mb-0 h-100 box-shadow-none">
                      <Row className="g-2">
                        <div>
                          <Card className="mb-1">
                            <CardBody>
                              <div>
                                <div className="d-md-flex mb-3 align-items-center">
                                  <div className="flex-grow-1 mb-md-0 mb-2">
                                    <h5 className="f-18 bold">Summary Analysis</h5>
                                  </div>
                                </div>
                                <div className="d-md-flex  align-items-center">
                                  <div className="flex-grow-1 mb-md-0 mb-2">
                                    <h5 className="f-18 bold">Strengths</h5>
                                  </div>
                                </div>

                                <div
                                  className="va-summary-main mt-2"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      Call_performance_response?.analysis_summary?.strengths ||
                                      'No Strengths Available.',
                                  }}
                                ></div>
                                <div className="d-md-flex  align-items-center">
                                  <div className="flex-grow-1 mb-md-0 mb-2">
                                    <h5 className="f-18 bold"> Areas of Improvement</h5>
                                  </div>
                                </div>

                                <div
                                  className="va-summary-main mt-2"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      Call_performance_response?.analysis_summary?.areas_of_improvement ||
                                      'No Area of Improvement Available.',
                                  }}
                                ></div>

                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </Row>
                      <Row className="g-2">
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              xAxisTitle="Week"
                              title="Assessment Discussion (%)"
                              yAxisTitle="% of Students"
                              barColors={[
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                                '#93ffa5',
                              ]}
                              options={
                                Call_performance_response?.weekly_assessment_discussed_student
                              }
                            />
                            {/* Call_performance_response?.assessment_discussed_students */}
                            {/* Call_performance_response?.draft_discussed_students */}
                            {/* {JSON.stringify(Call_performance_response)} */}
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <AssessmentDiscussionDraftChart
                              xAxisTitle="Week"
                              title="Draft Assessment Discussion (%)"
                              yAxisTitle="% of Students"
                              barColors={[
                                '#e6ccff',
                                '#e6ccff',
                                '#e6ccff',
                              ]}
                              options={
                                Call_performance_response?.weekly_draft_discussed_student
                              }
                            />
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card className="mt-2">
                    <CardBody>
                      <Row className="g-2">
                        {/* Section 2 */}

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Quality Score (%)"
                              yAxisTitle="Avg Call Quality Score (%)"
                              barColors={['#cceeff', '#cceeff']}
                              options={
                                Call_performance_response
                                  ?.weekly_average_scores?.call_quality
                              }
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <StudentSentimentChart
                              options={
                                Call_performance_response?.weekly_student_sentiments
                              }
                            />
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Coverage Score (%)"
                              yAxisTitle="Avg Call Coverage Score"
                              barColors={['#d0f0c0', '#d0f0c0']}
                              options={
                                Call_performance_response
                                  ?.weekly_average_scores?.call_coverage
                              }
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Engagement Score (%)"
                              yAxisTitle="Avg Engagement Score"
                              barColors={['#d6f5d6', '#d6f5d6']}
                              options={
                                Call_performance_response
                                  ?.weekly_average_scores?.engagement
                              }
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Clarity Score (%)"
                              yAxisTitle="Avg Clarity Score"
                              barColors={['#f0e68c', '#f0e68c']}
                              options={
                                Call_performance_response
                                  ?.weekly_average_scores?.clarity
                              }
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Connectivity Issues (%)"
                              yAxisTitle="% of Students"
                              barColors={[
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                                '#add8e6',
                              ]}
                              options={
                                Call_performance_response?.weekly_connectivity_issues_students
                              }
                            />
                          </Card>
                        </Col>

                        <Col md={6}>
                          <Card className="mb-0 h-100 border box-shadow-none">
                            <PlotBarChart
                              title="Recording Compliance (%)"
                              yAxisTitle="% of Students"
                              barColors={[
                                '#ffd9ec',
                                '#ffd9ec',
                                '#ffd9ec',
                              ]}
                              options={
                                Call_performance_response?.weekly_recording_compliance_students
                              }
                            />
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              ) : (
                <div>
                  {isApiLoading ? (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <Spinner />
                    </Card>
                  ) : (
                    <Card
                      className="mb-0 border box-shadow-none d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      No Call Perfomance is available for chosen metrics
                      or Choose different metrics
                    </Card>
                  )}
                </div>
              )}
            </Card>
          )}
          {activeTab === 'Insights' && (
            <Card className="mb-0" style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
              <CardBody>
                <TopicDiscussedTab
                  resetTrigger={resetTrigger}
                  fullURL={
                    process.env.REACT_APP_API_BASE_URL +
                    'individual_teacher_report/'
                  }
                  payload={payload}

                   isApiLoading={isApiLoading}

                   urlWeek={drillWeek}
  initialSubTab={drillSubTab}

  onStudentClick={handleFlaggedStudentClick}

                />{' '}
              </CardBody>
            </Card>

          )}
          {activeTab === 'Webinars' && (
            <Card style={{ borderTopLeftRadius: '0', borderRadius: "0" }}>
              <CardBody>
                <div className="">
                  <h5 className="bold">Sessions Details</h5>
                  <div className="d-flex flex-wrap gap-2">
                    <div className="flex-grow-1">
                      {/* <h5 className="f-16 bold">FAQ</h5> */}
                    </div>
                    <div className="ind-un-re">
                      <div className="d-flex justify-content-end flex-wrap gap-2">
                        <Dropdown
                          isOpen={webinarStatusDropdownOpen}
                          toggle={toggleWebinarStatusDropdown}
                        >
                          <DropdownToggle
                            className={`btn stu-period-bg`}
                            caret
                          >
                            Status <i className="mdi mdi-chevron-down" />
                          </DropdownToggle>

                          {/* Prevent dropdown from closing when typing */}
                          <DropdownMenu
                            className="p-0"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <input
                              type="text"
                              placeholder="Search status"
                              className="form-control"
                              value={webinarStatusSearch}
                              onChange={(e) =>
                                handleWebinarSearchChange(
                                  e,
                                  'webinarStatus',
                                )
                              }
                            />

                            {/* Static Items - Successful & Unsuccessful */}
                            {['Successful', 'Unsuccessful'].map(
                              (status, index) => (
                                <DropdownItem
                                  key={index}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleWebinarSelectItem(
                                      {
                                        id: status,
                                        name: status,
                                        removename: 'removewebinarstatus',
                                      },
                                      selectedWebinarStatus,
                                      setSelectedWebinarStatus,
                                      toggleWebinarStatusDropdown,
                                    );
                                  }}
                                >
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={selectedWebinarStatus.has(
                                        status,
                                      )}
                                      readOnly
                                    />
                                    <label className="form-check-label">
                                      {status}
                                    </label>
                                  </div>
                                </DropdownItem>
                              ),
                            )}
                          </DropdownMenu>
                        </Dropdown>

                        <button
                          type="button"
                          className="btn btn-primary border-0 py-1 px-3 me-1"
                          onClick={handleWebinarApply}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="filters-show">
                      <div className="selected-filters">
                        {showWebinarScrollButtons && (
                          <button
                            className="slider-button slider-button-left"
                            onClick={handleWebinarLeftClick}
                          >
                            <i className="ri-arrow-left-s-line"></i>
                          </button>
                        )}

                        <div
                          className="filter-summary"
                          ref={webinarFilterSummaryRef}
                          onMouseDown={startWebinarDrag}
                          onMouseMove={handleWebinarMouseMove}
                          onMouseUp={stopWebinarDrag}
                          onMouseLeave={stopWebinarDrag}
                          onTouchStart={startWebinarDrag} // Touch equivalent of onMouseDown
                          onTouchMove={handleWebinarMouseMove} // Touch equivalent of onMouseMove
                          onTouchEnd={stopWebinarDrag} // Touch equivalent of onMouseUp
                        >
                          {selectedWebinarStatus.size > 0 && (
                            <div className="filter-item">
                              {Array.from(selectedWebinarStatus).map(
                                (status, index) => (
                                  <p
                                    key={index}
                                    className="filter-tag mi-stone-type"
                                  >
                                    {status}
                                  </p>
                                ),
                              )}
                            </div>
                          )}
                        </div>

                        {showWebinarScrollButtons && (
                          <button
                            className="slider-button slider-button-right"
                            onClick={handleWebinarRightClick}
                          >
                            <i className="ri-arrow-right-s-line"></i>
                          </button>
                        )}
                      </div>
                      <div className="">
                        {hasWebinarSelections && (
                          <button
                            type="button"
                            className="clear-all-btn me-1"
                            onClick={clearAllWebinarSelections}
                          >
                            <i class="ri-close-fill"></i> Clear All
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {activeTab === 'Webinars' && (
                    <div>
                      <Card
                        className="border box-shadow-none mb-0 mt-2"
                        style={{ borderTopLeftRadius: '0' }}
                      >
                        <CardBody>
                          <div className="va-info-wrapper">
                            <WebinarGridTable
                              payload={payload}
                              classroom_id={classroom_id}
                              webinarAnalytics={webinarAnalytics}
                              appliedStatus={appliedWebinarStatus}
                              appliedUniversities={
                                (appliedUniversities.size > 0 &&
                                  appliedUniversities) ||
                                Deatilsofteacher?.appliedUniversities
                              }
                              appliedPrograms={
                                (appliedPrograms.size > 0 &&
                                  appliedPrograms) ||
                                Deatilsofteacher?.appliedPrograms
                              }
                              appliedTimelines={
                                (appliedTimelines.size > 0 &&
                                  appliedTimelines) ||
                                Deatilsofteacher?.appliedTimelines
                              }
                              appliedTerms={
                                (appliedTerms.size > 0 && appliedTerms) ||
                                Deatilsofteacher?.appliedTerms
                              }
                              appliedUnit={
                                (appliedUnit.size > 0 && appliedUnit) ||
                                (Deatilsofteacher?.unit_id
                                  ? new Set([Deatilsofteacher.unit_id])
                                  : new Set())
                              }
                              appliedTeacher={
                                (appliedTeacher.size > 0 &&
                                  appliedTeacher) ||
                                (Deatilsofteacher?.teacherid
                                  ? new Set([Deatilsofteacher.teacherid])
                                  : new Set())
                              }
                            />
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          )}
          {activeTab === 'Webinar Performance' && (
            <>
              <SummaryAnalysis classroom_id={classroom_id} payload={payload} resetTriger={resetTrigger} />
              <WebinarPerfomance
                webinarPerfomanceData={webinarPerfomanceData}
              />
            </>
          )}
          {activeTab === 'Webinar Insights' && (
            <WebinarInsightsTab
              resetTrigger={resetTrigger}
              fullURL={
                process.env.REACT_APP_API_BASE_URL +
                'individual_teacher_report/'
              }
              payload={payload}
            />
          )}

        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
      <style scoped>
        {`
        .data-card-value{
          width: 100%;
          padding: 12px;
          border: 1px solid #E8E8E9;
          border-radius: 6px;
        }
        .data-val{
          font-size: 16px;
          font-weight: bold;
          color: #1c1c1c;
        }
        .data-val{
          font-size: 14px;
        }
         .dcv-1{
          position: relative;
        }
        .dcv-1::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(235,255,238,1) 0%, rgba(162,234,179,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-2{
           position: relative;
        }
        .dcv-2::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(183,208,246,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-3{
           position: relative;
        }
        .dcv-3::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
          background: linear-gradient(180deg, rgba(255,210,210,1) 0%, rgba(247,148,150,1) 100%);
      
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-4{
          position: relative;
        }
        .dcv-4::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background:linear-gradient(180deg, rgba(230,238,255,1) 0%, rgba(147,151,255,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
        .dcv-5{
           position: relative;
        }
        .dcv-5::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, rgba(255,239,225,1) 0%, rgba(255,229,205,1) 100%);
        border-radius: 0px 32px 32px 0px;
        }
         .dcv-6{
           position: relative;
        }
        .dcv-6::after{
        content: '';
        position: absolute;
        top: 0;
        right: -1px;
        height:100%;
        width: 5px; /* Border width */
        background: linear-gradient(180deg, #96bdc900 0%, #53839299 100%);
        border-radius: 0px 32px 32px 0px;
        }
        
        @media (max-width:1199px) {
          .charts-card{
            display: flex;
            gap: 16px;
          }
        }
        @media (max-width:560px) {
          .charts-card{
            flex-wrap: wrap;
          }
        }
      `}
      </style>
    </React.Fragment>
  );
};

export default IndividualTeacherReport;
